import {useHistoricosCreditoCaixa, idHistoricoCredito, descricaoHistoricoCredito, colunaHistoricosCredito, DetalheHistoricoCreditoCaixa} from './components/HistoricosCreditoCaixa';
import {REGRA_PRAZO_SEMANAL} from './components/prazoFechamentoSemanal';
import {colunaFormasPagamento,formatarFormasPagamento} from './components/formasPagamentoMovimento';
import {resumirPrePagamentosCaixa} from './components/resumoPrePagamentosCaixa';
import {apiUrl} from './components/apiAmbiente';
import {formatarAcoesCaixa, iconeAcaoCaixa as iconeAcao, formatarIdMovimentoCaixa} from './components/acoesCaixa';
import MovimentoAgendasDetalhe from './MovimentoAgendasDetalhe';
import React, { useState, useEffect, useRef, useContext } from "react";
import { withRouter } from "react-router-dom";
import Loading from "./assets/loading4.gif";
import Logo from "./assets/MB_Logo.png";
import './caixamovcons.css';
import "./components/functions";
import 'react-tabulator/lib/styles.css'; // required styles
import 'react-tabulator/lib/css/tabulator.min.css'; // theme
import { ReactTabulator } from 'react-tabulator'; // for React 15.x, use import { React15Tabulator }
import { cl } from "./components/functions";
import axios from "axios";
import * as EmailValidator from 'email-validator';
import Inputmask from "inputmask";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from "moment";
import dateFormat from "dateformat";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Link, animateScroll as scroll } from "react-scroll";
import Hotkeys from 'react-hot-keys';
import date from 'date-and-time';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { DateTime } from 'luxon'
import {
  Document,
  HeadingLevel,
  ImageRun,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  VerticalAlign,
  WidthType
} from "docx";
//import * as fs from "fs";
//const fs = require('fs')

var gGlobal = require('./components/globalvar.js');

// AUX FLEX: linhas virtuais exclusivas para a grade semanal. Não altera a API, vendas ou impressão.
function montarApontamentosComFlex(registros) {
  if (!Array.isArray(registros)) return registros;
  const adicionais = [];
  registros.forEach((r, indice) => {
    const nome = String(r.auxiliar || '').trim();
    const valor = Number(String(r.flex_receber || '0').replace(/\./g, '').replace(',', '.'));
    if (!nome || nome === '-' || !Number.isFinite(valor) || valor <= 0) return;
    adicionais.push({
      ...r,
      id: String(r.id) + '-FLEX-' + indice,
      prof: nome,
      serv: String(r.serv || '') + ' (Auxiliar FLEX)',
      valor: '0,00', insumos: '0,00', getnet: '0,00', antecip: '0,00',
      porc: String(r.flex_porc || ''), auxiliar: '-', flex_receber: '0,00',
      receber: valor.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
      linhaAuxFlex: true
    });
  });
  return registros.concat(adicionais);
}

const wordIcon = function (cell, formatterParams) { //plain text value
  return "<i class='far fa-file-word'></i>";
};
const editIcon = function (cell, formatterParams) { //plain text value
  return "<i class='fas fa-edit'></i>";
};
const iconContrato = function (cell, formatterParams) { //plain text value
  return "<i class='fas fa-file-download'></i>";
};
const iconwhatsappweb = function (cell, formatterParams) { //plain text value
  return "<i class='fa fa-whatsapp'></i>";
}

const iconLixeira = function (cell, formatterParams) { //plain text value
  //if (cell.getRow().getData().progress < 11){
  return "<i class='fa fa-trash-o'></i>";
  //} else {
  //  return "-";
  //}
}


global.gLog = [];
global.gOpencaixa = 1;
global.gSubTotal = 0;
global.gAlertaCaixaMov = 0;
global.gSubTotalVales = 0;
global.gSubTotalAgendas = 0;

function idAgendaApontamento(registro) {
  const valor = String(registro?.id ?? '').trim();
  const texto = registro?.linhaAuxFlex ? valor.split('-FLEX-')[0] : valor;
  if (!/^\d+$/.test(texto)) return null;
  const id = Number(texto);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

function rowClick(e, row) {
  ////cl('ref table: ', this.ref.table); // this is the Tabulator table instance
  //cl("rowClick id: " + row.getData().id, row, e);
  ////cl(rep);

};


function Gerador() {

  const formatData = function (cell, formatterParams, onRendered) {
    //cell - the cell component
    //formatterParams - parameters set for the column
    //onRendered - function to call when the formatter has been rendered
    let dia = cell.getValue().substr(8, 2)
    let mes = cell.getValue().substr(5, 2)
    let ano = cell.getValue().substr(0, 4)
    let result = dia + '/' + mes + '/' + ano

    return result; //return the contents of the cell;  
  }

  const adultCalc = function (values, data, calcParams) {
    //values - array of column values
    //data - all table data
    //calcParams - params passed from the column definition object


    var calc = 0;

    values.forEach(function (value) {
      calc = calc + realParaNumber(value)
    });

    return calc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }

  const [movimentoDetalhe,setMovimentoDetalhe]=useState(null);
  const [agendaDetalheId,setAgendaDetalheId]=useState(null);
  const focoMovimentoRef=useRef(false);
  const [Atu, setAtu] = useState([]);
  const [rep, setrep] = useState([]);
  const [repCaixaOpen, setrepCaixaOpen] = useState([]);
  const [FinalizaPag, setFinalizaPag] = useState([]);
  const [AtuLanc, setAtuLanc] = useState([]);
  const [Lanc, setLanc] = useState([]);
  const [LancSelected, setLancSelected] = useState([]);
  const [openCaixa, setopenCaixa] = useState([]);
  const [AtuLancamentos, setAtuLancamentos] = useState('');
  const [Lancamentos, setLancamentos] = useState('');
  const historicosCredito=useHistoricosCreditoCaixa(global.gCaixaId,AtuLancamentos,Lancamentos);
  function abrirDetalheMovimento(r){if(r.historico_credito)historicosCredito.abrir(r);else setMovimentoDetalhe(r);}
  const [AtuRelComiss, setAtuRelComiss] = useState('');
  const [RelComiss, setRelComiss] = useState('');
  const [AtuRelComissResumo, setAtuRelComissResumo] = useState('');
  const [RelComissResumo, setRelComissResumo] = useState('');  
  const [EditLancamentos, setEditLancamentos] = useState('');
  const [AddLancManual, setAddLancManual] = useState('');
  const [FechaCaixa, setFechaCaixa] = useState('');


  const [DocNow, setDocNow] = useState([]);
  const isFirstRunAtuLanc = useRef(true);
  const isFirstRunOpenCaixa = useRef(true);
  const isFirstRunAtuLancamentos = useRef(true);
  const isFirstRunAtuRelAtuComiss = useRef(true);
  const isFirstRunAtuRelAtuComissResumo = useRef(true);
  const isFirstRunEditLancamentos = useRef(true);
  const isFirstRunFinalizaPag = useRef(true);
  const isFirstRunAddLancManual = useRef(true);
  const isFirstRunFechaCaixa = useRef(true);

  moment.updateLocale('pt-br', {
    week: {
      dow: 1,
      //doy: 1,
    },
  });


  useEffect(() => {


  }, [rep])

  useEffect(() => {


  }, [Lanc])

  useEffect(() => {

    /*     cl("moment0",moment().day(0).format('YYYY-MM-DD'));
        cl("moment1",moment().day(1).format('YYYY-MM-DD'));
        cl("moment2",moment().day(2).format('YYYY-MM-DD'));
        cl("moment3",moment().day(3).format('YYYY-MM-DD'));
        cl("moment4",moment().day(4).format('YYYY-MM-DD'));
        cl("moment5",moment().day(5).format('YYYY-MM-DD'));
        cl("moment6",moment().day(6).format('YYYY-MM-DD'));
        cl("moment7",moment().day(7).format('YYYY-MM-DD')); */


  }, [RelComiss])

  useEffect(() => {
    if (isFirstRunAddLancManual.current) {
      isFirstRunAddLancManual.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;
    //cl("AddLancManual", AddLancManual)

    const { tipo, desc, valor, idprof, Fpg, dtvenc } = AddLancManual
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('cliente', idprof);
      bodyFormData.set('caixa', global.gCaixaId);
      bodyFormData.set('tipo', tipo);
      bodyFormData.set('idprof', idprof);
      bodyFormData.set('desc', desc);
      bodyFormData.set('valor', valor);
      bodyFormData.set('dtvenc', dtvenc);
      bodyFormData.set(Fpg, valor);
      bodyFormData.set('user', global.gIdUser);
      const urlfull = apiUrl('AddLancCxManual.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response_data", response['data'])
      //setAtuLancamentos({ idagenda: global.gParams })

      setAtuLancamentos({ '0': '0' });
      setAtuRelComiss({ '0': '0' });
      setAtuRelComissResumo({ '0': '0' });
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          //setLancamentos(redata2);
          //CloseEditContr();
        } else {
          //setLancamentos(redata);
        }


      }
    }
    fetchdata();
    return () => { ignore = true };
  }, [AddLancManual])

  useEffect(() => {
    if (isFirstRunFechaCaixa.current) {
      isFirstRunFechaCaixa.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;
    //cl("FechaCaixa", FechaCaixa)

    const { sangria, vfinal } = FechaCaixa
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('caixa', global.gCaixaId);
      bodyFormData.set('tipo', 'F');
      bodyFormData.set('desc', 'Fechamento de Caixa');
      bodyFormData.set('valor', sangria);
      bodyFormData.set('valorfinal', vfinal);
      bodyFormData.set('cash', sangria);
      bodyFormData.set('user', global.gIdUser);
      const urlfull = apiUrl('FechaCaixa.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response_data", response['data'])
      //setAtuLancamentos({ idagenda: global.gParams })
      setAtuLancamentos({ '0': '0' });
      setAtuRelComiss({ '0': '0' });
      setAtuRelComissResumo({ '0': '0' });
      window.open("/caixa", "_self");
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          //setLancamentos(redata2);
          //CloseEditContr();
        } else {
          //setLancamentos(redata);
        }


      }
    }
    fetchdata();
    return () => { ignore = true };
  }, [FechaCaixa])



  useEffect(() => {


    //cl("LancSelected", LancSelected)
    if (LancSelected) {

      global.gLancSelected = LancSelected.toString();
    } else {

      global.gLancSelected = 'nenhum';
    }


  }, [LancSelected])

  useEffect(() => {



  }, [DocNow])

  useEffect(() => {
    if (isFirstRunAtuLancamentos.current) {
      isFirstRunAtuLancamentos.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    //const { idagenda } = AtuLancamentos
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      //bodyFormData.set('caixa', 4);
      bodyFormData.set('caixa', global.gCaixaId);
      const urlfull = apiUrl('listaCaixaMov.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response_data", response['data'])
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setLancamentos(redata2);
        } else {
          setLancamentos(redata);

        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata()
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuLancamentos])

  useEffect(() => {
    if (isFirstRunAtuRelAtuComiss.current) {
      isFirstRunAtuRelAtuComiss.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    //const { idagenda } = AtuLancamentos
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('dtinit', moment(global.dataConsCaixa).day(1).format('YYYY-MM-DD 00:00:00'));
      bodyFormData.set('dtfim', moment(global.dataConsCaixa).day(7).format('YYYY-MM-DD 23:59:59'));
      bodyFormData.set('marcio', 0);      
      bodyFormData.set('pdeb', 1.79);
      bodyFormData.set('pcred', 2.55);
      bodyFormData.set('pcredp', 4.9);
      bodyFormData.set('antecip', 3.6);
      bodyFormData.set('caixa', global.gCaixaId);
      const urlfull = apiUrl('listaRelComiss.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response_data", response['data'])
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setRelComiss(redata2);
        } else {
          setRelComiss(redata);

        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('imgloadingRelComiss');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata()
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuRelComiss])
  
  useEffect(() => {
    if (isFirstRunAtuRelAtuComissResumo.current) {
      isFirstRunAtuRelAtuComissResumo.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    //const { idagenda } = AtuLancamentos
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('dtinit', moment(global.dataConsCaixa).day(1).format('YYYY-MM-DD 00:00:00'));
      bodyFormData.set('dtfim', moment(global.dataConsCaixa).day(7).format('YYYY-MM-DD 23:59:59'));
      bodyFormData.set('marcio', 0);      
      bodyFormData.set('pdeb', 1.79);
      bodyFormData.set('pcred', 2.55);
      bodyFormData.set('pcredp', 4.9);
      bodyFormData.set('antecip', 3.6);
      bodyFormData.set('caixa', global.gCaixaId);
      const urlfull = apiUrl('listaRelComissResumo.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response_data", response['data'])
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setRelComissResumo(redata2);
          //cl("redata2", redata2)
        } else {
          setRelComissResumo(redata);
         // cl("redata", redata)


        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('imgloadingRelComissResumo');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata()
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuRelComissResumo])


  useEffect(() => {



  }, [RelComissResumo])

  useEffect(() => {
    if (isFirstRunFinalizaPag.current) {
      isFirstRunFinalizaPag.current = false;
      //cl("FirstRunDados false")
      return;
    }

  }, [FinalizaPag])


  useEffect(() => {
    if (isFirstRunEditLancamentos.current) {
      isFirstRunEditLancamentos.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;


    return () => { ignore = true };
  }, [EditLancamentos])

  useEffect(() => {

    global.gSubTotal = 0;
    global.gCash = 0;
    global.gDebito = 0;
    global.gCCv = 0;
    global.gCCp = 0;
    global.gPix = 0;
    global.gCC = 0;
    global.gSubTotalVales = 0;
    global.gSubTotalAgendas = 0;    
    global.gSubTotalAgendasCash = 0;
    global.gSubTotalAgendasCartao = 0;
    global.gSubTotalAgendasCC = 0;
    global.gSubTotalAgendasPix = 0;


    //cl("Lancamentos", Lancamentos);
    if (Lancamentos.length > 0) {


      var i;

      for (i = 0; i < Lancamentos.length; i++) {
        if (Lancamentos[i].tipo === 'E') {

          if (Lancamentos[i].valor) { global.gSubTotal = global.gSubTotal + (realParaNumber(Lancamentos[i].valor)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].valor)) { global.gSubTotalAgendas = global.gSubTotalAgendas + (realParaNumber(Lancamentos[i].valor)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].cash)) { global.gSubTotalAgendasCash = global.gSubTotalAgendasCash + (realParaNumber(Lancamentos[i].cash)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].cc)) { global.gSubTotalAgendasCC = global.gSubTotalAgendasCC + (realParaNumber(Lancamentos[i].cc)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].pix)) { global.gSubTotalAgendasPix = global.gSubTotalAgendasPix + (realParaNumber(Lancamentos[i].pix)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].creditoavista)) { global.gSubTotalAgendasCartao = global.gSubTotalAgendasCartao + (realParaNumber(Lancamentos[i].creditoavista)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].creditoparc)) { global.gSubTotalAgendasCartao = global.gSubTotalAgendasCartao + (realParaNumber(Lancamentos[i].creditoparc)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].debito)) { global.gSubTotalAgendasCartao = global.gSubTotalAgendasCartao + (realParaNumber(Lancamentos[i].debito)); }
          if (Lancamentos[i].cash) { global.gCash = global.gCash + (realParaNumber(Lancamentos[i].cash)); }
          if (Lancamentos[i].debito) { global.gDebito = global.gDebito + (realParaNumber(Lancamentos[i].debito)); }
          if (Lancamentos[i].creditoavista) { global.gCCv = global.gCCv + (realParaNumber(Lancamentos[i].creditoavista)); }
          if (Lancamentos[i].creditoparc) { global.gCCp = global.gCCp + (realParaNumber(Lancamentos[i].creditoparc)); }
          if (Lancamentos[i].pix) { global.gPix = global.gPix + (realParaNumber(Lancamentos[i].pix)); }
          if (Lancamentos[i].cc) { global.gCC = global.gCC + (realParaNumber(Lancamentos[i].cc)); }

        }

        if (Lancamentos[i].tipo === 'S') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash - (realParaNumber(Lancamentos[i].cash)); }

        }

        if (Lancamentos[i].tipo === 'V') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash - (realParaNumber(Lancamentos[i].cash)); }
          if (Lancamentos[i].cash) { global.gSubTotalVales = global.gSubTotalVales + (realParaNumber(Lancamentos[i].cash)); }

        }

        if (Lancamentos[i].tipo === 'F') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash - (realParaNumber(Lancamentos[i].cash)); }

        }

        if (Lancamentos[i].tipo === 'A') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash + (realParaNumber(Lancamentos[i].cash)); }

        }

      }
      let einputTotal = document.getElementById('inputTotal');
      if (einputTotal) { einputTotal.value = global.gSubTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputTotalAgendas = document.getElementById('inputTotalagendas');
      if (einputTotalAgendas) { einputTotalAgendas.value = global.gSubTotalAgendas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasCash = document.getElementById('inputTotalagendascash');
      if (einputTotalAgendasCash) { einputTotalAgendasCash.value = global.gSubTotalAgendasCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasPix = document.getElementById('inputTotalagendaspix');
      if (einputTotalAgendasPix) { einputTotalAgendasPix.value = global.gSubTotalAgendasPix.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasCartao = document.getElementById('inputTotalagendascartao');
      if (einputTotalAgendasCartao) { einputTotalAgendasCartao.value = global.gSubTotalAgendasCartao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasCC = document.getElementById('inputTotalagendascc');
      if (einputTotalAgendasCC) { einputTotalAgendasCC.value = global.gSubTotalAgendasCC.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalVales = document.getElementById('inputTotalvales');
      if (einputTotalVales) { einputTotalVales.value = global.gSubTotalVales.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      


      let einputCash = document.getElementById('inputCash');
      if (einputCash) { einputCash.value = global.gCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputDebito = document.getElementById('inputDebito');
      if (einputDebito) { einputDebito.value = global.gDebito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputCCv = document.getElementById('inputCCv');
      if (einputCCv) { einputCCv.value = global.gCCv.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputCCp = document.getElementById('inputCCp');
      if (einputCCp) { einputCCp.value = global.gCCp.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputPix = document.getElementById('inputPix');
      if (einputPix) { einputPix.value = global.gPix.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputCC = document.getElementById('inputCC');
      if (einputCC) { einputCC.value = global.gCC.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }

      let eimgloadingReactTabulatorCxMov = document.getElementById('imgloadingReactTabulatorCxMov');
      if (eimgloadingReactTabulatorCxMov) { eimgloadingReactTabulatorCxMov.style.display = 'none'; }

    }

    /* 
        let eimgloadingReactTabulatorCxMov = document.getElementById('imgloadingReactTabulatorCxMov');
        if (eimgloadingReactTabulatorCxMov) {
          eimgloadingReactTabulatorCxMov.style.display = 'none';
        }
    
        let edivReactTabulatorCxMov = document.getElementById('divReactTabulatorCxMov');
        if (edivReactTabulatorCxMov) {
          edivReactTabulatorCxMov.style.display = '';
        }
    
        btnFPGresetAll();
        global.gSubTotal = 0;
        var i
        if (Lancamentos) {
    
          for (i = 0; i < Lancamentos.length; i++) {
    
            global.gSubTotal = global.gSubTotal + (realParaNumber(Lancamentos[i].valor) * (realParaNumber(Lancamentos[i].qtd)));
    
          }
          let edivFormadePG = document.getElementById('divFormadePG');
          if (edivFormadePG) { edivFormadePG.style.display = ''; }
    
          let einputVConta = document.getElementById('inputVConta');
          let eibtnPgConta = document.getElementById('btnPgConta');
          if (Lancamentos.length > 1) {
            einputVConta.disabled = true;
            eibtnPgConta.disabled = true;
          } else {
            einputVConta.disabled = false;
            eibtnPgConta.disabled = false;
    
          }
    
    
    
        } else {
          let edivFormadePG = document.getElementById('divFormadePG');
          if (edivFormadePG) { edivFormadePG.style.display = 'none'; }
    
        }
        let einputTotal = document.getElementById('inputTotal');
        if (einputTotal) { einputTotal.value = global.gSubTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */
    //cl("global.gSubTotal", global.gSubTotal)
    //cl("Lancamentos mudou", Lancamentos)

  }, [Lancamentos])

  useEffect(() => {

    if (isFirstRunOpenCaixa.current) {
      isFirstRunOpenCaixa.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    if (global.gOpencaixa === 0) {

      //cl("openCaixa", openCaixa);
      //let iopen = dateFormat(Date.parse(openCaixa.open), "yyyy-mm-dd HH:MM:ss");
      let iopen = moment(openCaixa.open).format("YYYY-MM-DD");
      let itroco = realParaNumber(openCaixa.troco);
      //cl("iopen", iopen);
      //cl('itroco', itroco);

      async function fetchdata() {
        var bodyFormData = new FormData();
        bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
        bodyFormData.set('open', iopen);
        bodyFormData.set('troco', itroco);
        bodyFormData.set('user', global.gIdUser);

        const urlfull = apiUrl('OpenCaixa.php');
        //cl("urlfull",urlfull);
        const response = await axios({
          method: 'post',
          url: urlfull,
          data: bodyFormData,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
        //cl("response",response);
        if (response['data'] === 'caixa aberto ou já existe') {
          modalBase("Atenção", "O Caixa esta aberto ou Já existe caixa fechado para esta data !");
          //window.alert('O Caixa esta aberto ou Já existe caixa fechado para esta data !')
          return
        }
        //setrepCaixaOpen(response);

        setAtu({ '0': '0' });
        global.gOpencaixa = 1;
        if (!ignore) {

          let eleLoading = document.getElementById('divLoad');
          if (eleLoading) { eleLoading.style.display = 'none'; };
        }
      }


      fetchdata();
    }
    return () => { ignore = true };

  }, [openCaixa])

  function removeOptions(selectElement) {
    var i, L = selectElement.options.length - 1;
    for (i = L; i >= 0; i--) {
      selectElement.remove(i);
    }
  }


  useEffect(() => {

    if (repCaixaOpen['data']) {
      let epanelCxOpen = document.getElementById('panelCxOpen');
      if (epanelCxOpen) { epanelCxOpen.style.display = 'none'; }
      let epanelCxClose = document.getElementById('panelCxClose');
      if (epanelCxClose) { epanelCxClose.style.display = ''; }
      let etituloCxOpen = document.getElementById('tituloCxOpen');
      let epanelMovresumo = document.getElementById('panelMovresumo');
      //if (epanelMovresumo) { epanelMovresumo.style.display = 'none'; }
      let epanelMovaction = document.getElementById('panelMovaction');
      if (epanelMovaction) { epanelMovaction.style.display = 'none'; }
      let resp = repCaixaOpen['data'][0];
      if (etituloCxOpen) { etituloCxOpen.innerHTML = '>>> Caixa Aberto - ' + moment(resp.open).format("DD/MM/YYYY") + ' - ' + moment(resp.open).format("dddd, DD [de] MMMM YYYY") }
      //setAtuLanc({ '0': '0' });
      global.gCaixaId = resp['id'];
      if (global.gAlertaCaixaMov === 0) {


        let current = moment().startOf('day');
        //cl("dif",moment.duration(moment(resp.open).diff(current)).asDays())
        /*         if ((moment.duration(moment(resp.open).diff(current)).asDays()) < 0) {
                  let f1 = "O Caixa Aberto (" + moment(resp.open).format("DD/MM/YYYY") + ") não esta na data de hoje ! (" + moment(current).format("DD/MM/YYYY") + ")";
                  modalBase("Atenção", f1, "Revise e feche o caixa logo!")
                  global.gAlertaCaixaMov = 1;
                } */
      }


      //global.gOpencaixa = 1;

      //cl("ok repCaixaOpen data", repCaixaOpen['data']);
      let k;
      let eSelectagenda = document.getElementById('SelectConsultaCaixa');
      removeOptions(document.getElementById('SelectConsultaCaixa'));
      let opt = document.createElement('option');
      opt.value = 0;
      opt.innerHTML = 'Selecione...';
      eSelectagenda.appendChild(opt);
      for (k = 0; k < repCaixaOpen['data'].length; k++) {
        let opt = document.createElement('option');
        opt.value = repCaixaOpen['data'][k]['id'];
        opt.innerHTML = moment(repCaixaOpen['data'][k]['open']).format('DD/MM/YYYY') + ' - ' + moment(repCaixaOpen['data'][k]['open']).locale('pt-br').format('dddd');
        eSelectagenda.appendChild(opt);

      }

      const destinoParams = new URLSearchParams(window.location.search);
      const destinoMov = Number(destinoParams.get('movimento_id') || 0);
      const destinoCaixa = Number(destinoParams.get('caixa_id') || 0);
      const destinoData = String(destinoParams.get('caixa_data') || '').slice(0,10);
      if (destinoMov && Array.isArray(repCaixaOpen.data)) {
        const caixas = repCaixaOpen.data;
        const escolhido = caixas.find(x => (destinoCaixa && Number(x.id)===destinoCaixa) || (destinoData && String(x.open||'').slice(0,10)===destinoData));
        if (escolhido) {
          const caixaFechado = !!(escolhido.close && String(escolhido.close).startsWith('20'));
          if (!caixaFechado) {
            window.location.replace('/caixa-mov?movimento_id='+destinoMov);
            return;
          }
          eSelectagenda.value = String(escolhido.id);
          // Mesmo fluxo de abertura usado quando a data e escolhida manualmente.
          selectConsCx();
          global.gCaixaId = escolhido.id;
          global.dataConsCaixa = String(escolhido.open).slice(0,10);
          global.cxselecionado = moment(escolhido.open).format('DD/MM/YYYY') + ' - ' + moment(escolhido.open).locale('pt-br').format('dddd');
          if (etituloCxOpen) etituloCxOpen.textContent='>>> Caixa Selecionado - '+global.cxselecionado;
          // Os refreshes sao disparados por selectConsCx().
        }
      }

            //acertar caixa id
      //setAtuLancamentos({ 'caixa': global.gCaixaId })
      //setAtuRelComiss({ 'caixa': global.gCaixaId })


    } else {
      //  cl("no repCaixaOpen data");
      let epanelCxClose = document.getElementById('panelCxClose');
      if (epanelCxClose) { epanelCxClose.style.display = ''; }
      let epanelCxOpen = document.getElementById('panelCxOpen');
      if (epanelCxOpen) { epanelCxOpen.style.display = 'none'; }
      let epanelMovresumo = document.getElementById('panelMovresumo');
      //if (epanelMovresumo) { epanelMovresumo.style.display = 'none'; }
      let epanelMovaction = document.getElementById('panelMovaction');
      if (epanelMovaction) { epanelMovaction.style.display = 'none'; }
      global.gOpencaixa = 0;
      //window.open("/caixa", "_self");

    }


  }, [repCaixaOpen])


  useEffect(() => {
    /*     if (isFirstRunDados.current) {
          isFirstRunDados.current = false;
          //cl("FirstRunDados false")
          return;
        } */
    let ignore = false;

    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      //bodyFormData.set('numcontr', gGlobal.gContrato);
      //bodyFormData.set('comp', 1);
      //bodyFormData.set('password', password);
      //bodyFormData.append('password', 'senha');
      const urlfull = apiUrl('listaConsultaCaixa.php');
      //cl("urlfull",urlfull);
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response", response);
      setrepCaixaOpen(response);
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setrep(redata2);
          //cl("redata2",redata2);
        } else {
          setrep(redata);
          //cl("redata",redata);
        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];



        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata();
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [Atu])

  useEffect(() => {
    /*     if (isFirstRunAtuLanc.current) {
          isFirstRunAtuLanc.current = false;
          //cl("FirstRunDados false")
          return;
        } */
    let ignore = false;

    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');

      const urlfull = apiUrl('listaFecha.php');
      //cl("urlfull",urlfull);
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response",response);
      //setrepCaixaOpen(response);
      setLanc(response['data']);
      setAtu({ '0': '0' });
      if (!ignore) {
        /*         const redata = [{}];
                const redata2 = response['data'];
                if (redata2) {
                  setrep(redata2);
                } else {
                  setrep(redata);
                } */
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }


    fetchdata();

    return () => { ignore = true };
  }, [AtuLanc])

  const ref = null;
  function paramLookup() {
    //do some processing and return the param object
    return { param1: "green" };
  }


  // Ajustes auditados em caixas fechados: apenas profissional e AUX FLEX.
  const [ajusteFechado, setAjusteFechado] = useState(null);
  const [ajusteAgendas, setAjusteAgendas] = useState([]);
  const [ajusteAgenda, setAjusteAgenda] = useState('');
  const [ajusteServicos, setAjusteServicos] = useState([]);
  const [ajusteLinha, setAjusteLinha] = useState('');
  const [ajusteTipo, setAjusteTipo] = useState('transferir_servico');
  const [ajusteDestino, setAjusteDestino] = useState('');
  const [ajusteProfissionais, setAjusteProfissionais] = useState([]);
  const [ajusteFlex, setAjusteFlex] = useState([]);
  const [ajusteMotivo, setAjusteMotivo] = useState('');
  const [ajusteErro, setAjusteErro] = useState('');
  const [ajusteSalvando, setAjusteSalvando] = useState(false);
  const [ajustePermitido, setAjustePermitido] = useState(false);
  const API_AJUSTES = apiUrl('CorrecaoOperacional.php');
  async function requisicaoAjustes(acao, dados={}) {
    const form = new FormData();
    form.append('token',sessionStorage.getItem('KEY_APP_BGG')||'');
    form.append('acao',acao);
    Object.keys(dados).forEach(k=>form.append(k,String(dados[k])));
    const response=await axios.post(API_AJUSTES,form);
    if(!response.data || !response.data.ok) throw new Error(response.data?.erro||'Falha na API');
    return response.data;
  }
  async function abrirAjusteFechado(row) {
    const ids=[...new Set(String(row.idagenda||'').split(',').map(x=>x.trim()).filter(x=>/^\d+$/.test(x)))];
    if(!ids.length || global.gTipoUser!=='A') return;
    setAjusteFechado(row);setAjusteAgendas(ids);setAjusteAgenda(ids[0]);
    setAjusteTipo('transferir_servico');setAjusteMotivo('');setAjusteDestino('');setAjusteErro('');setAjustePermitido(false);setAjusteServicos([]);
    try {
      const [opcoes,detalhes]=await Promise.all([requisicaoAjustes('listar_destinos'),requisicaoAjustes('consultar_servicos',{agenda_id:ids[0]})]);
      setAjusteProfissionais(opcoes.profissionais||[]);setAjusteFlex(opcoes.auxiliares||[]);
      setAjusteServicos(detalhes.servicos||[]);setAjusteLinha('');setAjustePermitido(true);
    }catch(e){setAjusteErro(e.response?.data?.erro||e.message);}
  }
  async function selecionarAgendaAjuste(id) {
    setAjusteAgenda(id);setAjusteLinha('');setAjusteErro('');setAjustePermitido(false);setAjusteServicos([]);
    try {const r=await requisicaoAjustes('consultar_servicos',{agenda_id:id});setAjusteServicos(r.servicos||[]);setAjustePermitido(true);}
    catch(e){setAjusteErro(e.response?.data?.erro||e.message);}
  }
  async function salvarAjusteFechado() {
    if(!ajustePermitido || global.gTipoUser!=='A')return;
    if(ajusteMotivo.trim().length<20){setAjusteErro('Justificativa obrigatória de pelo menos 20 caracteres.');return;}
    if(ajusteTipo!=='transferir_agenda' && !ajusteLinha){setAjusteErro('Selecione um serviço.');return;}
    if(!ajusteDestino && ajusteTipo!=='aux_flex_salvar'){setAjusteErro('Selecione o profissional de destino.');return;}
    const servico=ajusteServicos.find(s=>String(s.id)===ajusteLinha);
    const destinoNome=ajusteTipo==='aux_flex_salvar' ? (ajusteFlex.find(x=>String(x.id)===ajusteDestino)?.nome||'Nenhum (remover)') : (ajusteProfissionais.find(x=>String(x.id)===ajusteDestino)?.nome||'');
    confirmAlert({closeOnClickOutside:false,customUI:({onClose})=><div className="custom-ui" style={{maxWidth:560,padding:0}}>
      <div className="modal-header bg-info text-white"><h5 className="modal-title">Confirmar alteração</h5></div>
      <div className="modal-body"><p><b>Agenda #{ajusteAgenda}</b> · {ajusteTipo==='transferir_agenda'?'Agenda completa':servico?.descricao_servico||servico?.descricao_produto||'Serviço'}</p>
      <p><b>Ação:</b> {ajusteTipo==='aux_flex_salvar'?'Alterar AUX FLEX':'Transferir profissional'} · <b>Destino:</b> {destinoNome}</p>
      <p><b>Justificativa:</b> {ajusteMotivo}</p><div className="alert alert-warning">Alteração imediata, com histórico e notificação ao Auditor.</div></div>
      <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={onClose}>Voltar</button><button type="button" className="btn btn-success" onClick={()=>{onClose();executarAjusteFechado();}}>Confirmar e registrar</button></div>
    </div>});
  }
  async function executarAjusteFechado(){
    if(ajusteSalvando || !ajustePermitido || global.gTipoUser!=='A')return;setAjusteSalvando(true);setAjusteErro('');
    try {
      const params={agenda_id:ajusteAgenda,lanc_id:ajusteLinha,novo_prof:ajusteDestino,idprof_flex:ajusteDestino,
        justificativa:ajusteMotivo.trim(),codigo_requisicao:'MB'+Date.now().toString(36)+Math.random().toString(36).slice(2,20)};
      const result=await requisicaoAjustes(ajusteTipo,params);setAjusteFechado(null);
      setAtuRelComiss({alteracao:Date.now()});setAtuRelComissResumo({alteracao:Date.now()});
      window.alert('Correção registrada. Ocorrência nº '+result.ocorrencia_id);
    }catch(e){setAjusteErro(e.response?.data?.erro||e.message);}finally{setAjusteSalvando(false);}
  }
  const colunaAcaoFechado={title:'<i class="fas fa-tools" title="Ações administrativas"></i>',formatter:cell=>{
    const d=cell.getRow().getData();if(d.historico_credito)return '';const ids=String(d.idagenda||'').split(',').filter(x=>/^\d+$/.test(x.trim()));
    return global.gTipoUser==='A' && ids.length ? formatarAcoesCaixa({profissional:iconeAcao('transferencia','Transferir profissional ou alterar AUX FLEX','fas fa-user-edit')}) : '';
  },width:82,minWidth:82,hozAlign:'center',headerSort:false,responsive:0,cellClick:(e,cell)=>{
    if (e.stopPropagation) e.stopPropagation();
    const d=cell.getRow().getData();
    const alvo=e.target && e.target.closest ? e.target.closest('[data-acao]') : null;
    if (alvo && String(d.idagenda||'').trim()) abrirAjusteFechado(d);
    else abrirDetalheMovimento(d);
  }};

  const columns = [
    colunaAcaoFechado,
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    { title: 'Id', field: 'id', hozAlign: 'center', width: 54, visible: true, headerSort: false, responsive: 0, headerSortStartingDir: "asc", formatter: cell=>idHistoricoCredito(cell,formatarIdMovimentoCaixa), cellClick: (e,cell) => { if (e.stopPropagation) e.stopPropagation(); abrirDetalheMovimento(cell.getRow().getData()); } },
    /* { title: 'Caixa', field: 'open', hozAlign: 'center', width: 120, visible: true, responsive: 0, headerSort: false }, */
    { title: 'Descrição', field: 'descricao', formatter: descricaoHistoricoCredito, variableHeight: true, hozAlign: "left", width: 250, responsive: 0, headerSort: false, headerFilter: "input" },
    { title: 'Op', field: 'tipo', hozAlign: "center", width: 10, responsive: 0, headerSort: false, },
    { title: 'Total R$', field: 'valor', hozAlign: "right", width: 70, responsive: 0, headerSort: false },
    colunaHistoricosCredito(colunaFormasPagamento()),

    /*       {
      title: 'Comis.(%)', field: 'porc', hozAlign: "center", width: 100, responsive: 0, headerSort: false, sorter: "string", headerSortStartingDir: "desc", formatter: function (cell, formatterParams, onRendered) {
        
        let textoAjustado = cell.getValue();
        
        return textoAjustado + " %";
      }
    }, */
    /*  { title: 'Editar', formatter: editIcon, width: 70, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { if (cell.getRow().getData().status == 'finalizado') { editLanc((cell.getRow().getData().id), (cell.getRow().getData().valor), (cell.getRow().getData().qtd), (cell.getRow().getData().descricao), (cell.getRow().getData().idagenda)) } } }, */
  ];
  const columnsRel = [
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    { title: 'Id', field: 'id', hozAlign: 'center', width: 54, visible: true, headerSort: false, responsive: 0, headerSortStartingDir: "asc", formatter: (cell) => {
      const id = idAgendaApontamento(cell.getRow().getData());
      if (!id) return '-';
      const botao = document.createElement('button');
      botao.type = 'button';
      botao.className = 'mbhair-id-agenda-apontamento';
      botao.textContent = String(id);
      botao.title = 'Abrir detalhamento completo do agendamento #' + id;
      return botao;
    }, cellClick: (e,cell) => {
      e.stopPropagation();
      const id = idAgendaApontamento(cell.getRow().getData());
      if (id) setAgendaDetalheId(id);
    } },
    { title: 'Agenda', field: 'agenda', align: 'center', width: 90, responsive: 0, formatter: formatData },
    /* { title: 'Caixa', field: 'open', hozAlign: 'center', width: 120, visible: true, responsive: 0, headerSort: false }, */
    { title: 'Descrição', field: 'cliente', hozAlign: "left", width: 200, responsive: 0, headerSort: false },
    /* { title: 'Profissional', field: 'prof', hozAlign: "left", width: 125, responsive: 0, headerSort: false }, */
    { title: 'Serviço', field: 'serv', hozAlign: "left", width: 200, responsive: 0, headerSort: false },
    { title: 'Total R$', field: 'valor', hozAlign: "right", width: 70, responsive: 0, headerSort: false },
    { title: 'Auxiliar R$', field: 'flex_receber', hozAlign: 'right', width: 88, responsive: 0, headerSort: false, formatter: function(cell) { const row = cell.getRow().getData(); const nome = String(row.auxiliar || '-'); const valor = String(cell.getValue() || '0,00'); const esc = v => v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;').replace(/'/g, '&#39;'); return '<span title=\"' + esc(nome) + '\">' + esc(valor) + '</span>'; } },
    { title: 'Insumos R$', field: 'insumos', hozAlign: "right", width: 80, responsive: 0, headerSort: false },
    { title: 'Getnet %', field: 'getnet', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    { title: 'Antecip %', field: 'antecip', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    { title: '%', field: 'porc', hozAlign: "right", width: 40, responsive: 0, headerSort: false },
    { title: 'Receber', field: 'receber', hozAlign: "right", width: 90, responsive: 0, headerSort: false, bottomCalc: adultCalc },
    /*       {
      title: 'Comis.(%)', field: 'porc', hozAlign: "center", width: 100, responsive: 0, headerSort: false, sorter: "string", headerSortStartingDir: "desc", formatter: function (cell, formatterParams, onRendered) {
        
        let textoAjustado = cell.getValue();
        
        return textoAjustado + " %";
      }
    }, */
    /*  { title: 'Editar', formatter: editIcon, width: 70, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { if (cell.getRow().getData().status == 'finalizado') { editLanc((cell.getRow().getData().id), (cell.getRow().getData().valor), (cell.getRow().getData().qtd), (cell.getRow().getData().descricao), (cell.getRow().getData().idagenda)) } } }, */
  ];
  
  const columnsRelResumo = [
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    //    { title: 'Id', field: 'id', hozAlign: 'center', width: 10, visible: true, headerSort: false, responsive: 0, headerSortStartingDir: "asc" },
    //    { title: 'Agenda', field: 'agenda' ,align: 'center', width: 90, responsive:0, formatter:formatData},
    /* { title: 'Caixa', field: 'open', hozAlign: 'center', width: 120, visible: true, responsive: 0, headerSort: false }, */
    //    { title: 'Descrição', field: 'cliente', hozAlign: "left", width: 250, responsive: 0, headerSort: false },
    { title: 'Profissional', field: 'prof', hozAlign: "left", width: 125, responsive: 0, headerSort: false },
    //    { title: 'Serviço', field: 'serv', hozAlign: "left", width: 150, responsive: 0, headerSort: false },
    //    { title: 'Total R$', field: 'valor', hozAlign: "right", width: 70, responsive: 0, headerSort: false },
    //    { title: 'Insumos R$', field: 'insumos', hozAlign: "right", width: 80, responsive: 0, headerSort: false },
    //    { title: 'Getnet %', field: 'getnet', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    //    { title: 'Antecip %', field: 'antecip', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    //    { title: '%', field: 'porc', hozAlign: "right", width: 40, responsive: 0, headerSort: false },
    { title: 'Total R$', field: 'vendas', hozAlign: "right", width: 100, responsive: 0, headerSort: false },
    { title: 'Débitos R$', field: 'debitos', hozAlign: "right", width: 100, responsive: 0, headerSort: false },
    { title: 'Receber R$', field: 'receber', hozAlign: "right", width: 100, responsive: 0, headerSort: false, formatter:function(cell, formatterParams){
      var value = cell.getValue();
           return "<span style='color:#2b622e; font-weight:bold;'>" + value + "</span>";

   }},
    //{ title: 'Classificação', field: 'star', hozAlign: "right", width: 90, responsive: 0, headerSort: false, formatter:'star', formatterParams:{stars:5} },
    { title: 'Vendas', field: 'progress', hozAlign: "left", width: 90, responsive: 0, headerSort: false, formatter:'progress', formatterParams:{color:["rgb(255,0,0)", "#38b544f5","#00fd00" ]} },
    { title: 'Rentabilidade', field: 'rentprogress', hozAlign: "left", width: 90, responsive: 0, headerSort: false, formatter:'progress', formatterParams:{color:["rgb(255,0,0)", "#38b544f5","#00fd00" ]} }
    /*       {
      title: 'Comis.(%)', field: 'porc', hozAlign: "center", width: 100, responsive: 0, headerSort: false, sorter: "string", headerSortStartingDir: "desc", formatter: function (cell, formatterParams, onRendered) {
        
        let textoAjustado = cell.getValue();
        
        return textoAjustado + " %";
      }
    }, */
    /*  { title: 'Editar', formatter: editIcon, width: 70, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { if (cell.getRow().getData().status == 'finalizado') { editLanc((cell.getRow().getData().id), (cell.getRow().getData().valor), (cell.getRow().getData().qtd), (cell.getRow().getData().descricao), (cell.getRow().getData().idagenda)) } } }, */
  ];




  const movimentoDestino = Number(new URLSearchParams(window.location.search).get('movimento_id') || 0);
  const destacarMovimento = row => {
    if (!movimentoDestino || Number(row.getData().id) !== movimentoDestino) return;
    const el = row.getElement();
    el.classList.add('mbhair-mov-alvo');
    if (!focoMovimentoRef.current) {
      focoMovimentoRef.current=true;
      setTimeout(() => {if(el.isConnected) el.scrollIntoView({behavior:'auto',block:'center'});}, 150);
    }
  };
  const options = {
    rowFormatter: destacarMovimento,
    //autoResize:false,
    //height: 125,
    // movableRows: true,
    clipboard: true,
    //resizableRows:true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:["APP_Teste"],
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout: "collapse",
    /*     initialSort: [
          { column: "id", dir: "asc" }, //sort by this first
        ] */
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };

  const optionsRel = {
    //autoResize:false,
    //height: 125,
    // movableRows: true,
    clipboard: true,
    groupBy: "prof",
    groupHeader: function (value, count, data, group) {
      //value - the value all members of this group share
      //count - the number of rows in this group
      //data - an array of all the row data objects in this group
      //group - the group component for the group

      if (count <= 1) {

        return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " item)</span>";
      } else {

        return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " items)</span>";
      }
    },
    //resizableRows:true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:"prof",
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout: "collapse",
    /*     initialSort: [
          { column: "id", dir: "asc" }, //sort by this first
        ] */
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };

  const optionsRelResumo = {
    //autoResize:false,
    //height: 125,
    // movableRows: true,
/*     printAsHtml:true,
    printHeader:"<h1>Resumo nesta Semana<h1>",
    printFooter:"<h2>--<h2>",  */     
    clipboard: true,
    /*     groupBy:"prof",
        groupHeader:function(value, count, data, group){
          //value - the value all members of this group share
          //count - the number of rows in this group
          //data - an array of all the row data objects in this group
          //group - the group component for the group
      
          if (count <= 1){
    
            return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " item)</span>";
          } else {
            
            return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " items)</span>";
          }
      }, */
    //resizableRows:true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:"prof",
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout: "collapse",
    /*     initialSort: [
          { column: "id", dir: "asc" }, //sort by this first
        ] */
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };

  function whatsappweb(nome, fone) {
    let link = "https://api.whatsapp.com/send?phone=55" + fone.replace(/_|-| |\(|\)/g, '') + "&text=Olá " + nome
    window.open(link, '_blank');

  }

  function novoCadastro(params) {


    let etituloContr = document.getElementById('tituloContr');
    etituloContr.innerHTML = "Novo Cadastro ..."

    global.gLog = [];


    let ele = document.getElementById('panelActions');
    ele.style.display = '';

    let eQtdInicial = document.getElementById('QtdInicial');
    eQtdInicial.style.display = '';

    let einputCodBarras = document.getElementById('inputCodBarras');
    einputCodBarras.value = '';
    einputCodBarras.focus();

    let elenome = document.getElementById('inputNome');
    elenome.value = '';
    elenome.disabled = false;

    let einputGrupo = document.getElementById('inputGrupo');
    einputGrupo.value = '';


    let einputValorCusto = document.getElementById('inputValorCusto');
    einputValorCusto.value = '';

    let einputValor = document.getElementById('inputValor');
    einputValor.value = '';

    let einputUnidade = document.getElementById('inputUnidade');
    einputUnidade.value = '';

    let einputQtdMin = document.getElementById('inputQtdMin');
    einputQtdMin.value = '';


    let einputPorc = document.getElementById('inputPorc');
    einputPorc.value = '';

  }


  function editCadastro(params) {

    let eQtdInicial = document.getElementById('QtdInicial');
    eQtdInicial.style.display = 'none';

    let ele = document.getElementById('panelActions');
    ele.style.display = '';

    let etituloContr = document.getElementById('tituloContr');
    etituloContr.innerHTML = "Editar Produto ..."

    var arrFound = rep.filter(function (item, num) {
      return item.id === params;
    });

    global.gLog = arrFound[0];
    //cl("global.gLog", global.gLog);
    let dtfinal = '';
    /*    if(arrFound[0].dtnasc){
          
          let dt = arrFound[0].dtnasc.split("/");
          dtfinal = ''+dt[2]+'-'+dt[1]+'-'+dt[0]+'';
        } else {
          dtfinal = '';
        } */

    //cl(dtfinal);

    let eleCodBarras = document.getElementById('inputCodBarras');
    eleCodBarras.value = arrFound[0].ean;

    let elenome = document.getElementById('inputNome');
    elenome.value = arrFound[0].descricao;
    //elenome.disabled = true;

    let einputValor = document.getElementById('inputValor');
    einputValor.value = arrFound[0].valor;

    let einputUnidade = document.getElementById('inputUnidade');
    einputUnidade.value = arrFound[0].unidade;

    let einputValorCusto = document.getElementById('inputValorCusto');
    einputValorCusto.value = arrFound[0].valor_custo;

    let einputQtdMin = document.getElementById('inputQtdMin');
    einputQtdMin.value = arrFound[0].estoque_min;

    let einputGrupo = document.getElementById('inputGrupo');
    einputGrupo.value = arrFound[0].grupo;

    let einputPorc = document.getElementById('inputPorc');
    einputPorc.value = parseFloat(arrFound[0].porc.replace(',', '.'));


    //validaFone();
    CalcSimule();


  }

  function editLanc(id, valor, qtd, descricao, idagenda) {


    // cl(id, valor, qtd);


    confirmAltLanc(id, valor, qtd, descricao, idagenda);

    let einputMQtd = document.getElementById('inputMQtd');
    einputMQtd.value = qtd;
    let einputMValor = document.getElementById('inputMValor');
    einputMValor.value = valor;
    /*       setEditLancamentos({
            id: 126,
            valor: "400,00",
            qtd: 1
          })
    
          setAtuLancamentos({ idagenda: global.gidAgenda }) */

  }

  function btnFinalizarPG(params) {

    let einputVCash = document.getElementById('inputVCash');
    let rVCash = realParaNumber(einputVCash.value);
    let einputVTroco = document.getElementById('inputVTroco');
    let rVTroco = realParaNumber(einputVTroco.value);
    let einputVCD = document.getElementById('inputVCD');
    let rVCD = realParaNumber(einputVCD.value);
    let einputVCC = document.getElementById('inputVCC');
    let rVCC = realParaNumber(einputVCC.value);
    let einputVCCx = document.getElementById('inputVCCx');
    let rVCCx = realParaNumber(einputVCCx.value);
    let einputVPix = document.getElementById('inputVPix');
    let rVPIX = realParaNumber(einputVPix.value);
    let einputVConta = document.getElementById('inputVConta');
    let rConta = realParaNumber(einputVConta.value);


    let somaFPG = rConta;
    somaFPG = somaFPG + rVCash;
    somaFPG = somaFPG + rVCD;
    somaFPG = somaFPG + rVCC;
    somaFPG = somaFPG + rVCCx;
    somaFPG = somaFPG + rVPIX;

    //cl("somaFPG",somaFPG);
    //cl("global.gSubTotal",somaFPG);

    let descricao = 'Pagamento - Agenda (' + LancSelected.toString() + ')';
    if ((global.gSubTotal === somaFPG) || (global.gSubTotal < somaFPG)) {



      confirmFinalizarPG(descricao, global.gSubTotal, rVCash, rVTroco, rVCD, rVCC, rVCCx, rVPIX, rConta);
    } else {
      //window.alert("A Soma das formas de Pagamento não confere, revise ou preencha!")
      modalBase("Atenção", "A Soma das formas de Pagamento não confere, revise ou preencha!");
    }





  }

  function confirmFinalizarPG(desc, rVTotal, rVCash, rVTroco, rVCD, rVCC, rVCCx, rVPIX, rConta) {
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Confirmação para Finalizar Pagamento</h4>
            </div>
            <div className="modal-body">
              <p>Após finalizar o Pagamento não será mais possível alterar!</p>
            </div>
            <div className="modal-body">
              <p>Tem Certeza ?</p>
            </div>
            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-success btn-sm float-right"
              onClick={() => {

                setFinalizaPag({
                  cliente: '',
                  caixa: global.gCaixaId,
                  idagenda: LancSelected.toString(),
                  tipo: 'C',
                  desc: desc,
                  valor: rVTotal,
                  cash: rVCash,
                  troco: rVTroco,
                  debito: rVCD,
                  creditoavista: rVCC,
                  creditoparc: rVCCx,
                  pix: rVPIX,
                  cc: rConta
                })

                onClose();
              }}
            >
              Sim, finalizar!
            </button>
          </div>
        );
      }
    });
  }

  function confirmAltLanc(id, valor, qtd, descricao, idagenda) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    let lqtd = qtd;

    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">{descricao}</h4>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Qtd.</label>
                <div className="input-group-prepend">
                  <input type="number" className="form-control" autocomplete="off" id="inputMQtd" />
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Valor R$</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" autocomplete="off" id="inputMValor" />
                </div>
              </div>
            </div>

            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                let einputMValor = document.getElementById('inputMValor');
                let einputMQtd = document.getElementById('inputMQtd');


                setEditLancamentos({
                  id: id,
                  valor: realParaNumber(einputMValor.value),
                  qtd: einputMQtd.value,
                  idagenda: idagenda
                })

                onClose();
              }}
            >
              Sim
            </button>
          </div>
        );
      }
    });
  }

  function btnconfirmFechaCx(params) {

    confirmFechaCx();
    let einputCxTValor = document.getElementById('inputCxTValor');
    einputCxTValor.value = global.gCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

  }

  function calcProxCx(vtotal, sangria) {

    let sang = realParaNumber(document.getElementById(sangria).value);
    let result = global.gCash - sang;
    if (result >= 0) {

      document.getElementById(vtotal).value = result.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    } else {
      window.alert("O Valor da Sangria não pode ser maior que o Saldo Atual !");
      document.getElementById(sangria).value = global.gCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      result = 0;
      document.getElementById(vtotal).value = result.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }

    //cl(vtotal, sangria);

  }

  function confirmFechaCx(id, valor, qtd, descricao, idagenda) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    let lqtd = qtd;


    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Fechamento de Caixa - Sangria</h4>
            </div>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="lEmail3">Saldo Atual</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" disabled autocomplete="off" id="inputCxTValor" />
                </div>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="lEmail3">Sangria</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" onChange={() => calcProxCx('inputCxProx', 'inputCxSangria')} autocomplete="off" id="inputCxSangria" />
                </div>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="lEmail3">Próximo Caixa</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" disabled autocomplete="off" id="inputCxProx" />
                </div>
              </div>
            </div>

            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                let einputCxSangria = document.getElementById('inputCxSangria');
                let einputCxProx = document.getElementById('inputCxProx');

                if (!einputCxSangria.value) {
                  einputCxSangria.focus();
                  return
                }
                if (!einputCxProx.value) {
                  einputCxSangria.focus();
                  return
                }

                // return


                setFechaCaixa({
                  sangria: realParaNumber(einputCxSangria.value),
                  vfinal: realParaNumber(einputCxProx.value),
                })

                onClose();
              }}
            >
              Fechar Caixa
            </button>
          </div>
        );
      }
    });
  }

  function selectChange(params) {

    let einputMIdProf = document.getElementById('inputMIdProf');
    let einputMDtVenc = document.getElementById('inputMDtVenc');
    let eSelectTipo = document.getElementById('SelectTipo');
    let eSelectFpg = document.getElementById('SelectFpg');

    if (eSelectTipo.value === "V") {
      einputMIdProf.disabled = false;
      einputMDtVenc.disabled = false;
      einputMIdProf.focus();
      eSelectFpg.value = "cash";
      eSelectFpg.disabled = true;
    } else {

      einputMIdProf.disabled = true;
      einputMDtVenc.disabled = true;
      eSelectFpg.disabled = false;
    }

  }

  function selectProf(params) {
    let einputMDesc = document.getElementById('inputMDesc');
    let einputMIdProf = document.getElementById('inputMIdProf');

    einputMDesc.value = '(' + einputMIdProf.children[einputMIdProf.selectedIndex].textContent + ') VALE : ' + einputMDesc.textContent;

  }

  function confirmMovCx(id, valor, qtd, descricao, idagenda) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    let lqtd = qtd;

    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Lançamento manual/avulso no Caixa</h4>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Tipo Movimentção</label>
                <div className="input-group-prepend">
                  <select className="form-control select2 select2-hidden-accessible" onChange={() => selectChange()} id="SelectTipo" tabIndex={-1} aria-hidden="true">
                    <option >selecione</option>
                    <option value="E">Entrada</option>
                    <option value="S">Saída</option>
                    <option value="V">Vale Profissional</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">ID Prof.</label>
                <div className="input-group-prepend">
                  <select className="form-control select2 select2-hidden-accessible" onChange={() => selectProf()} disabled id="inputMIdProf" tabIndex={-1} aria-hidden="true">
                    <option >selecione</option>
                    <option value="6">César</option>
                    <option value="8">Gal</option>
                    <option value="2">Jorge</option>
                    <option value="9">Josy</option>
                    <option value="5">Júlio</option>
                    <option value="3">Kaká</option>
                    <option value="17">Lucas</option>
                    <option value="4">Rey</option>
                    <option value="10">Val</option>
                    <option value="1">Márcio Bagagine</option>
                  </select>
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Vencimento</label>
                <div className="input-group-prepend ">
                  <input type="date" className="form-control" disabled autocomplete="off" id="inputMDtVenc" />
                </div>
              </div>

            </div>
            <div className="form-row">
              <div className="form-group col-md-12">
                <label htmlFor="lEmail3">Descrição</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" autocomplete="off" id="inputMDesc" />
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Valor R$</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" autocomplete="off" id="inputMValor" />
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Forma de Pagamento</label>
                <div className="input-group-prepend">
                  <select className="form-control select2 select2-hidden-accessible" id="SelectFpg" tabIndex={-1} aria-hidden="true">
                    <option >selecione</option>
                    <option value="cash">Dinheiro</option>
                    <option value="debito">Débito</option>
                    <option value="creditoavista">Credito à Vista</option>
                    <option value="creditoparc">Crédito Parc.</option>
                    <option value="pix">PIX</option>
                    <option value="cc">CC</option>
                  </select>
                </div>
              </div>

            </div>

            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                let eSelectTipo = document.getElementById('SelectTipo');
                let eSelectFpg = document.getElementById('SelectFpg');
                let einputMValor = document.getElementById('inputMValor');
                let einputMDesc = document.getElementById('inputMDesc');
                let einputMIdProf = document.getElementById('inputMIdProf');
                let einputMDtVenc = document.getElementById('inputMDtVenc');

                if (eSelectTipo.value === 'selecione') {
                  eSelectTipo.focus();
                  return
                }
                if ((eSelectTipo.value === 'V') && (!einputMIdProf.value)) {
                  einputMIdProf.focus();
                  return
                }
                if ((eSelectTipo.value === 'V') && (!einputMDtVenc.value)) {
                  einputMDtVenc.focus();
                  return
                }

                if (!einputMDesc.value) {
                  einputMDesc.focus();
                  return
                }

                if (!einputMValor.value) {
                  einputMValor.focus();
                  return
                }

                if (eSelectFpg.value === 'selecione') {
                  eSelectFpg.focus();
                  return
                }

                //return


                setAddLancManual({
                  tipo: eSelectTipo.value,
                  desc: einputMDesc.value,
                  valor: realParaNumber(einputMValor.value),
                  idprof: einputMIdProf.value,
                  Fpg: eSelectFpg.value,
                  dtvenc: einputMDtVenc.value
                })

                onClose();
              }}
            >
              Sim
            </button>
          </div>
        );
      }
    });
  }


  function realParaNumber(texto) {
    //cl("realParaNumber",texto)
    if (texto === '') {
      return 0
    }
    var compativelComParseFloat = texto.replace(/R|\$|\./g, '');
    // //cl("texto R$",compativelComParseFloat);
    compativelComParseFloat = compativelComParseFloat.replace(/,/g, '.');
    ////cl("texto ,.",compativelComParseFloat);
    var valor = parseFloat(compativelComParseFloat);
    //cl("valor",valor);

    return valor;
  }

  function ajustaInputMoney(params) {

    let eleVUnit = document.getElementById('inputValorTroco');
    let Vunit = realParaNumber(eleVUnit.value);
    eleVUnit.value = Vunit.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

  }

  function CalcSimule(params) {

    /*     var iNf_valor = document.getElementById("inputNf_valor");
        let V_Nf_valor = realParaNumber(iNf_valor.value);
        if (V_Nf_valor) { iNf_valor.value = V_Nf_valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */

    var iVlr_pago = document.getElementById("inputValor");
    let V_pago = realParaNumber(iVlr_pago.value);
    if (V_pago) { iVlr_pago.value = V_pago.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
    /* 
        var iDif = document.getElementById("inputDif");
        let V_dif = realParaNumber(iDif.value);
        if (V_dif) { iDif.value = V_dif.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */

    /*     var iPcc = document.getElementById("inputPcc");
        let V_Pcc = realParaNumber(iPcc.value);
        if (V_Pcc) { iPcc.value = V_Pcc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */

    /*     if ((iNf_valor.disabled === false) && (iVlr_pago.disabled === false) && (iDif.disabled === false)) {
          V_dif = V_pago - V_Nf_valor;
          if (V_dif > 0) {
            iDif.value = V_dif.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          }
        } */
    /* 
        if ((iNf_valor.disabled === false) && (iPcc.disabled === false)) {
          V_Pcc = V_Nf_valor * 0.045;
          if (V_Pcc > 0) {
            iPcc.value = V_Pcc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          }
        } */




  }

  function validaOpenCaixa(params) {

    let einputDtCx = document.getElementById('inputDtCx');
    if (!einputDtCx.value) {
      window.alert('Selecione a Data de Abertura !!!')
      einputDtCx.focus();
      return
    };





    modalCaixaOpen(document.getElementById('inputDtCx').value, document.getElementById('inputValorTroco').value);

  }

  function modalBase(h1, p, p2, focus, inputquery) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">{h1}</h4>
            </div>
            <div className="modal-body">
              <p>{p}</p>
            </div>
            <div className="modal-body">
              <p>{p2}</p>
            </div>
            {/* <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button> */}
            <button id="btnModal"
              className="btn bg-gradient-info float-right"
              onClick={() => {
                if (focus) {
                  document.getElementById(focus).focus();
                  // cl("focus")
                }
                if (inputquery) {
                  let inputM = document.querySelectorAll('input');
                  //cl("inputmodal",inputM)
                  inputM[inputquery].focus();
                }

                //alert('Em desenvolvimento no backend/servidor');
                onClose();
              }}
            >
              Ok
            </button>
          </div >
        );
      }
    });
  }

  function modalCaixaOpen(data, troco) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Abertura de Caixa</h4>
            </div>
            <div className="modal-body">
              <p>Tem certeza que deseja realizar a Abertura para o</p>
              <p>Dia {moment(data).format("DD/MM/YYYY")} com Troco de {troco} ?</p>
            </div>
            <button className="btn bg-gradient-danger btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-success btn-sm float-right"
              onClick={() => {

                setopenCaixa({
                  open: data,
                  troco: troco,
                  user: global.gIdUser
                })
                onClose();

              }}
            >
              Sim, abrir agora!
            </button>
          </div>
        );
      }
    });
  }

  function confirmDelProp(numprop, cliente) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <h1>Deseja Deletar este Contrato da proposta ?</h1><br></br><br></br>
            <p id='pmodal'><b>{numprop} - {cliente}</b></p>
            <br></br>
            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                //alert('Em desenvolvimento no backend/servidor');
                /*                 setDelContr(
                                  {
                                    'numprop': numprop
                                  }); */
                onClose();
              }}
            >
              Sim, apague agora!
            </button>
          </div>
        );
      }
    });
  }

  function selectConsCx(params) {

    let eSelectConsultaCaixa = document.getElementById('SelectConsultaCaixa');

    let epanelCxOpen = document.getElementById('panelCxOpen');
    if (epanelCxOpen) { epanelCxOpen.style.display = ''; }
    let epanelCxClose = document.getElementById('panelCxClose');
    if (epanelCxClose) { epanelCxClose.style.display = ''; }
    let etituloCxOpen = document.getElementById('tituloCxOpen');
    let epanelMovresumo = document.getElementById('panelMovresumo');
    //if (epanelMovresumo) { epanelMovresumo.style.display = 'none'; }
    let epanelMovaction = document.getElementById('panelMovaction');
    if (epanelMovaction) { epanelMovaction.style.display = 'none'; }
    let resp = repCaixaOpen['data'][0];
    global.cxselecionado = eSelectConsultaCaixa.children[eSelectConsultaCaixa.selectedIndex].textContent;
    if (etituloCxOpen) { etituloCxOpen.innerHTML = '>>> Caixa Selecionado - ' + global.cxselecionado }
    //setAtuLanc({ '0': '0' });
    global.gCaixaId = eSelectConsultaCaixa.value;
    global.dataConsCaixa = moment(eSelectConsultaCaixa.children[eSelectConsultaCaixa.selectedIndex].textContent.slice(0,10), "DD/MM/YYYY").format("YYYY-MM-DD");

    setAtuLancamentos({ 'caixa': eSelectConsultaCaixa.value })
    setAtuRelComiss({ 'datacx': global.dataConsCaixa })
    setAtuRelComissResumo({ 'datacx': global.dataConsCaixa })

    let ecardRelComiss = document.getElementById('cardRelComiss');
    ecardRelComiss.classList.remove("collapsed-card");


  }

  function testeImp(params) {
    var conteudo = document.getElementById('cardSelCaixa').innerHTML,
      tela_impressao = window.open('about:blank');

    tela_impressao.document.write(conteudo);
    tela_impressao.window.print();
    //tela_impressao.window.close();

  }

  function CaixaFechado(params) {
    return (
      <div id="panelCxClose" name="panelCxClose" style={{ position: 'relative', display: '' }}>
        <section className="content no-print">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-danger cardAddBgg" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloContr">Selecione o Caixa</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label htmlFor="lNome">Selecione o Caixa que deseja Consultar</label>
                        <select className="form-control select2 select2-hidden-accessible" id="SelectConsultaCaixa" onChange={() => selectConsCx()} data-select2-id={1} tabIndex={-1} aria-hidden="true">
                          {/*                             <option selected="selected" data-select2-id={3}>Link para questionário Incial</option>
                            <option data-select2-id={29}>Cotação Inicial</option> */}
                        </select>

                      </div>
                      <div className="form-group col-md-6">
                        <button type="button" className="btn btn-info float-right" id="btnGravarClose" onClick={e => testeImp()}>Cancelar</button>
                      </div>
                    </div>

                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function CaixaAberto(params) {
    return (
      <div id="panelCxOpen" name="panelCxOpen" style={{ position: 'relative', display: '' }}>
        <section className="content no-print">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-success cardAddBgg" id="cardSelCaixa" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Caixa Aberto</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label id="labelDualList" htmlFor="lNome">Movimentações realizadas no Caixa</label>
                        {historicosCredito.erro&&<p className="alert alert-warning" role="alert">Não foi possível consultar os créditos históricos: {historicosCredito.erro}</p>}
                        {historicosCredito.detalhe&&<DetalheHistoricoCreditoCaixa registro={historicosCredito.detalhe} fechar={historicosCredito.fechar}/>}

                        <button type="button" className="btn bg-gradient-info btn-sm no-print" style={{marginLeft: 12}} onClick={imprimirCaixa}>Imprimir Caixa</button>

                        <img id="imgloadingReactTabulatorCxMov" style={{ display: '' }} className="row col-md-12" alt="Loading.." src={Loading}></img>
                        {movimentoDetalhe&&<MovimentoAgendasDetalhe movimento={movimentoDetalhe} onClose={()=>setMovimentoDetalhe(null)}/>}
                        <div id="divReactTabulatorCxMov" >
                          <ReactTabulator
                            name="rcardSelCaixaBody"
                            id="rcardSelCaixaBody"
                            // ref={(ref)}
                            columns={columns}
                            data={historicosCredito.linhas}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={options}
                            events={{rowClick:(e,row)=>{if(e.target?.closest?.('[data-acao]') || e.target?.closest?.('.fa-user-edit'))return;abrirDetalheMovimento(row.getData());}}}
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          />
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }


  // Impressão independente do AdminLTE e das tabelas Tabulator.
  const escapePrint = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const moneyNumber = (value) => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
    const s = String(value == null ? '' : value).trim().replace(/[^\d,.-]/g, '');
    if (!s) return 0;
    const normalized = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
    const n = Number(normalized);
    return Number.isFinite(n) ? n : 0;
  };
  const RELATORIO_VERSAO = 'V14.0 • 16/10/2026';
  const moneyPrint = (value) => moneyNumber(value).toLocaleString('pt-BR', {style:'currency',currency:'BRL'});
  const datePrint = (value) => {
    if (!value) return '';
    const m = moment(value, ['YYYY-MM-DD HH:mm:ss','YYYY-MM-DD','DD/MM/YYYY'], true);
    return m.isValid() ? m.format('DD/MM/YYYY') : String(value);
  };
  const printCell = (value, numeric = false) => `<td${numeric ? ' class="num"' : ''}>${escapePrint(value)}</td>`;
  const printTable = (headers, rows, kind = '') => {
    const widths = kind === 'cash' ? [7,30,5,13,45] : kind === 'detail' ? [5,8,15,19,9,9,7,7,7,7,7] : kind === 'summary' ? [22,17,14,17,14,16] : [];
    const cols = widths.length ? `<colgroup>${widths.map(w => `<col style=\"width:${w}%\">`).join('')}</colgroup>` : '';
    return `<table class=\"print-table ${kind}\">${cols}<thead><tr>${headers.map((h,i) => `<th${(kind === 'cash' && i === 3) || (kind === 'detail' && i >= 4) || (kind === 'summary' && i >= 1) ? ' class=\"num\"' : ''}>${escapePrint(h)}</th>`).join('')}</tr></thead><tbody>${rows.join('')}</tbody></table>`;
  };

  function abrirRelatorioImpressao(titulo, subtitulo, conteudo, paisagem) {
    const frame = document.createElement('iframe');
    frame.setAttribute('title', 'Relatório para impressão');
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none';
    document.body.appendChild(frame);
    const css = `@page{size:A4 ${paisagem ? 'landscape' : 'portrait'};margin:${paisagem ? '9mm 9mm 10mm' : '9mm 8mm 10mm'}}
      *{box-sizing:border-box}html,body{margin:0;padding:0;background:#fff;color:#202a33;font-family:Arial,Helvetica,sans-serif;font-size:${paisagem ? '8.5px' : '8.6px'};line-height:1.23;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
      h1{font-size:16px;margin:0 0 3px;color:#1d3448}h2{font-size:10.5px;margin:10px 0 5px;padding:5px 7px;background:#eaf0f5!important;border-left:3px solid #294b64}
      .sub{font-size:9px;color:#576775;margin-bottom:8px}.report-version{float:right;font-size:7px;color:#7b8790;font-weight:normal;letter-spacing:.15px}.top{border-bottom:2px solid #294b64;padding-bottom:6px;margin-bottom:8px}
      table{border-collapse:collapse;width:100%;table-layout:fixed;margin:0 0 7px}th,td{border-bottom:1px solid #d4dde4;padding:${paisagem ? '3px 3px' : '2.8px 2px'};text-align:left;overflow-wrap:break-word;word-break:normal;vertical-align:top}
      th{background:#dce7ee!important;color:#263a49;font-size:${paisagem ? '8px' : '7.5px'};font-weight:bold}td.num,th.num{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}
      .print-table.cash{font-size:9.5px}.print-table.cash th{font-size:9px}.print-table.cash td.num{font-size:9.5px;letter-spacing:0}.print-table.cash td:nth-child(4),.print-table.cash th:nth-child(4){text-align:left}.print-table.cash .print-payment{text-align:left;line-height:1.35}.print-table.cash td:nth-child(3){text-align:center}.print-table.cash td:nth-child(2){white-space:normal;overflow-wrap:anywhere;word-break:normal;line-height:1.3}
      .print-table.detail{font-size:7.4px}.print-table.detail th{font-size:7.1px}.print-table.detail td.num{font-size:7.2px;letter-spacing:-.12px}.print-table.detail td:nth-child(7),.print-table.detail td:nth-child(8),.print-table.detail td:nth-child(9){text-align:right;font-variant-numeric:tabular-nums}
      .print-table.summary td:nth-child(n+2){text-align:right;font-variant-numeric:tabular-nums}
      /* Relatório exclusivo do resumo semanal: replica visual do quadro com barras do sistema */
      .weekly-only{max-width:100%;margin-top:10px}
      .weekly-only table{font-size:11.4px;table-layout:fixed;border:1px solid #bfc8cf}
      .weekly-only th,.weekly-only td{padding:8px 7px;vertical-align:middle;border-bottom:1px solid #cfd7dd;border-right:1px solid #d5dde3}
      .weekly-only th:last-child,.weekly-only td:last-child{border-right:0}
      .weekly-only th{font-size:10.8px;background:#dce7ee!important;color:#263a49;font-weight:bold}
      .weekly-only td.amount{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}
      .weekly-only td.receivable{font-weight:700;color:#245d2b}
      .weekly-only .progress-track{width:100%;height:22px;position:relative;background:transparent!important;overflow:hidden;border-radius:0}
      .weekly-only .progress-fill{height:22px;display:block;max-width:100%;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
      .weekly-only .progress-low{background:rgb(255,0,0)!important}
      .weekly-only .progress-mid{background:#38b544!important}
      .weekly-only .progress-high{background:#00fd00!important}
      .weekly-only tbody tr:nth-child(even) td{background:#ebebeb!important}
      .weekly-only tbody tr:nth-child(odd) td{background:#fff!important}
      .weekly-only tr{break-inside:avoid;page-break-inside:avoid}
      .weekly-only .summary-bar-cell{padding:6px 6px}
      .weekly-only h2{text-align:center;font-size:15px;background:transparent!important;border:0;margin-bottom:12px}
      .weekly-only tbody tr.weekly-total td{background:#dce7ee!important;border-top:2px solid #7793a5;font-weight:700;padding-top:10px;padding-bottom:10px}
      .weekly-only tbody tr.weekly-total td.receivable{color:#245d2b}

      tbody tr:nth-child(odd) td{background:#fff!important}tbody tr:nth-child(even) td{background:#e9f1f6!important}
      thead{display:table-header-group}tr{break-inside:avoid;page-break-inside:avoid}.group{font-weight:bold}.subtotal td{font-weight:bold;background:#d8e6ef!important;border-top:1px solid #9fb4c3}
      .cards{display:grid;grid-template-columns:repeat(${paisagem ? '4' : '3'},1fr);gap:5px;margin-bottom:7px}.metric{border:1px solid #d8e2e8;border-radius:3px;padding:5px;break-inside:avoid}.metric span{display:block;color:#647480;font-size:8px}.metric strong{display:block;font-size:11px;margin-top:2px}
      .small{font-size:8px;color:#60707e}.end{margin-top:7px;border-top:1px solid #d7e0e6;padding-top:5px}.group-title{font-weight:bold;background:#dce9f2!important;padding:5px;margin-top:9px;break-after:avoid;page-break-after:avoid}
      .print-table.cash td{padding-top:1.7px;padding-bottom:1.7px} .print-table.cash{margin-bottom:4px} .report-section{margin-bottom:5px}.report-section h2{break-after:avoid;page-break-after:avoid}.report-section:has(.cards){break-inside:avoid;page-break-inside:avoid}
      @media print{html,body{width:auto;height:auto}a{color:inherit;text-decoration:none}}`;
    const footer = `<footer class="end small">Espaço Márcio Bagagine • ${escapePrint(RELATORIO_VERSAO)} • Emitido em ${escapePrint(moment().format('DD/MM/YYYY HH:mm'))}</footer>`;
    const conteudoFinal = !paisagem && conteudo.endsWith('</section>') ? conteudo.slice(0, -10) + footer + '</section>' : conteudo + footer;
    const html = `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${escapePrint(titulo)}</title><style>${css}</style></head><body><header class="top"><span class="report-version">Relatório ${escapePrint(RELATORIO_VERSAO)}</span><h1>${escapePrint(titulo)}</h1><div class="sub">${escapePrint(subtitulo)}</div></header>${conteudoFinal}</body></html>`;
    let printed = false;
    let cleaned = false;
    const cleanup = () => { if (!cleaned) { cleaned = true; setTimeout(() => { if (frame.parentNode) frame.parentNode.removeChild(frame); }, 1000); } };
    frame.onload = () => {
      if (printed) return;
      printed = true;
      try {
        const win = frame.contentWindow;
        win.addEventListener('afterprint', cleanup, {once:true});
        win.focus();
        win.print();
      } catch (e) { cleanup(); modalBase('Impressão', 'Não foi possível abrir a impressão. Verifique as permissões do navegador.'); }
    };
    frame.srcdoc = html;
  }

  function imprimirCaixa() {
    if (!global.gCaixaId || !global.dataConsCaixa || !Array.isArray(Lancamentos)) {
      modalBase('Impressão', 'Selecione um caixa e aguarde o carregamento das movimentações.'); return;
    }
    const totals = {entradas:0, cash:0, debito:0, vista:0, parc:0, pix:0, cc:0, pre:0, perm:0, agendas:0, agCash:0, agCartao:0, agPix:0, agCC:0, vales:0};
    Lancamentos.forEach(r => {
      const v = k => moneyNumber(r[k]);
      if (r.tipo === 'E') {
        totals.entradas += v('valor'); totals.cash += v('cash'); totals.debito += v('debito'); totals.vista += v('creditoavista'); totals.parc += v('creditoparc'); totals.pix += v('pix'); totals.cc += v('cc'); totals.pre += v('pre_pago'); totals.perm += v('permuta');
        if (r.idagenda) { totals.agendas += v('valor'); totals.agCash += v('cash'); totals.agCartao += v('debito')+v('creditoavista')+v('creditoparc'); totals.agPix += v('pix'); totals.agCC += v('cc'); }
      } else if (['S','V','F'].includes(r.tipo)) { totals.cash -= v('cash'); if (r.tipo === 'V') totals.vales += v('cash'); }
      else if (r.tipo === 'A') totals.cash += v('cash');
    });
    const metrics = (items) => `<div class="cards">${items.map(([label,val])=>`<div class="metric"><span>${escapePrint(label)}</span><strong>${escapePrint(moneyPrint(val))}</strong></div>`).join('')}</div>`;
    const headers = ['ID','Descrição','Op.','Total','Forma de Pagamento'];
    const rows = Lancamentos.map(r => `<tr>${printCell(r.id)}${printCell(r.descricao)}${printCell(r.tipo)}${printCell(moneyPrint(r.valor),true)}${`<td class="print-payment">${escapePrint(formatarFormasPagamento(r))}</td>`}</tr>`);
    const content = `<section class="report-section"><h2>Movimentações realizadas no Caixa (${Lancamentos.length})</h2>${printTable(headers,rows,'cash')}</section>
      <section class="report-section"><h2>Resumo Caixa e Vendas</h2>${metrics([['Saldo no Caixa',totals.cash],['Total de Entradas',totals.entradas],['Débito',totals.debito],['Crédito à Vista',totals.vista],['Crédito Parcelado',totals.parc],['PIX',totals.pix],['CC',totals.cc],['Pré-pago utilizado',totals.pre],['Permuta utilizada',totals.perm]])}</section>
      <section class="report-section"><h2>Resumo de Faturamento — Agendas</h2>${metrics([['Total Agendas',totals.agendas],['Cartão',totals.agCartao],['PIX',totals.agPix],['CC',totals.agCC],['Dinheiro',totals.agCash]])}</section>
      <section class="report-section"><h2>Resumo de Vales</h2>${metrics([['Total de Vales',totals.vales]])}</section>`;
    abrirRelatorioImpressao('Relatório de Caixa',`Caixa de ${global.cxselecionado || datePrint(global.dataConsCaixa)} • Nº ${global.gCaixaId}`,content,false);
  }

  function imprimirSomenteResumoSemanal() {
    if (!global.dataConsCaixa || !Array.isArray(RelComissResumo)) {
      modalBase('Impressão', 'Selecione um caixa e aguarde o carregamento do resumo semanal.');
      return;
    }
    const ini = moment(global.dataConsCaixa).isoWeekday(1).format('DD/MM/YYYY');
    const fim = moment(global.dataConsCaixa).isoWeekday(7).format('DD/MM/YYYY');

    // Localiza SOMENTE a tabela do resumo, nunca as movimentações do caixa.
    // Os dados impressos continuam vindo de RelComissResumo.
    const resumoTable = Array.from(
      document.querySelectorAll('#cardRelComiss .tabulator')
    ).find(table => {
      const labels = Array.from(table.querySelectorAll('.tabulator-header .tabulator-col'))
        .map(col => (col.textContent || '').trim().toLowerCase());
      return labels.some(s => s.includes('profissional')) &&
             labels.some(s => s.includes('rentabilid'));
    });

    const barrasPorProfissional = new Map();
    if (resumoTable) {
      Array.from(resumoTable.querySelectorAll('.tabulator-row')).forEach(row => {
        const cells = Array.from(row.querySelectorAll(':scope > .tabulator-cell'));
        if (cells.length < 6) return;
        const nome = (cells[0].textContent || '').trim();
        if (nome) barrasPorProfissional.set(nome, [cells[4], cells[5]]);
      });
    }

    // Reproduz as cores que o formatter 'progress' do Tabulator já calculou.
    // Não copia HTML/linhas da tela: lê apenas a cor da barra, por profissional.
    const corDaBarra = (cell, valor) => {
      if (cell) {
        const candidatos = Array.from(cell.querySelectorAll('*')).reverse();
        for (const el of candidatos) {
          const inline = el.style && (el.style.backgroundColor || el.style.background);
          const computed = window.getComputedStyle(el).backgroundColor;
          const cor = inline || computed;
          if (!cor) continue;
          const normal = String(cor).toLowerCase().replace(/\s/g, '');
          if (normal === 'transparent' || normal === 'rgba(0,0,0,0)') continue;
          if (normal.includes('255,0,0') || normal.includes('#ff0000') || normal === 'red') return '#ff0000';
          if (normal.includes('56,181,68') || normal.includes('56,181,69') || normal.includes('#38b544')) return '#38b544';
          if (normal.includes('0,253,0') || normal.includes('#00fd00')) return '#00fd00';
        }
      }
      // Reserva para situações em que a tabela ainda não foi renderizada.
      const n = Math.max(0, Math.min(100, moneyNumber(valor)));
      return n < 33.34 ? '#ff0000' : (n < 66.67 ? '#38b544' : '#00fd00');
    };

    const barra = (value, cell) => {
      const n = Math.max(0, Math.min(100, moneyNumber(value)));
      const cor = corDaBarra(cell, value);
      return `<td class="summary-bar-cell"><div class="progress-track" role="img" aria-label="${escapePrint(n.toLocaleString('pt-BR'))}%"><span class="progress-fill" style="width:${n}%;background-color:${cor}!important"></span></div></td>`;
    };
    const linhas = RelComissResumo.map(r => {
      const cells = barrasPorProfissional.get(String(r.prof || '').trim()) || [];
      return `<tr>
        <td>${escapePrint(r.prof)}</td>
        <td class="amount">${escapePrint(r.vendas)}</td>
        <td class="amount">${escapePrint(r.debitos)}</td>
        <td class="amount receivable">${escapePrint(r.receber)}</td>
        ${barra(r.progress, cells[0])}${barra(r.rentprogress, cells[1])}
      </tr>`;
    }).join('');

    // Totais calculados em centavos para não acumular imprecisões de ponto flutuante.
    const somaCentavos = (campo) => RelComissResumo.reduce(
      (total, item) => total + Math.round(moneyNumber(item[campo]) * 100), 0
    );
    const numeroBR = (centavos) => (centavos / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    const totalGeral = `<tr class="weekly-total">
      <td>TOTAL GERAL</td>
      <td class="amount">${escapePrint(numeroBR(somaCentavos('vendas')))}</td>
      <td class="amount">${escapePrint(numeroBR(somaCentavos('debitos')))}</td>
      <td class="amount receivable">${escapePrint(numeroBR(somaCentavos('receber')))}</td>
      <td></td><td></td>
    </tr>`;

    const content = `<section class="weekly-only report-section">
      <h2>Resumo nesta Semana (${escapePrint(moment(global.dataConsCaixa).isoWeekday(1).format('DD/MM'))} à ${escapePrint(moment(global.dataConsCaixa).isoWeekday(7).format('DD/MM/YYYY'))})</h2>
      <table><colgroup><col style="width:21%"><col style="width:14%"><col style="width:14%"><col style="width:15%"><col style="width:18%"><col style="width:18%"></colgroup>
      <thead><tr><th>Profissional</th><th>Total R$</th><th>Débitos R$</th><th>Receber R$</th><th>Vendas</th><th>Rentabilidade</th></tr></thead>
      <tbody>${linhas}${totalGeral}</tbody></table>
    </section>`;
    abrirRelatorioImpressao('Resumo Semanal', `Período: ${ini} a ${fim}`, content, false);
  }

  function imprimirConferenciaSemanal() {
    if (!global.dataConsCaixa || !Array.isArray(RelComiss) || !Array.isArray(RelComissResumo)) {
      modalBase('Impressão', 'Selecione um caixa e aguarde o carregamento dos relatórios semanais.'); return;
    }
    const ini = moment(global.dataConsCaixa).isoWeekday(1).format('DD/MM/YYYY');
    const fim = moment(global.dataConsCaixa).isoWeekday(7).format('DD/MM/YYYY');
    const sumRows = RelComissResumo.map(r => `<tr>${printCell(r.prof)}${printCell(moneyPrint(r.vendas),true)}${printCell(moneyPrint(r.debitos),true)}${printCell(moneyPrint(r.receber),true)}${printCell(r.progress)}${printCell(r.rentprogress)}</tr>`);
    const sumFields = ['vendas','debitos','receber'];
    const sumTotals = sumFields.map(k => RelComissResumo.reduce((a,r)=>a+moneyNumber(r[k]),0));
    sumRows.push(`<tr class="subtotal"><td>TOTAL GERAL</td>${sumTotals.map(n=>printCell(moneyPrint(n),true)).join('')}<td></td><td></td></tr>`);
    const groups = new Map();
    RelComiss.forEach(r => { const name = String(r.prof || 'Sem profissional'); if(!groups.has(name)) groups.set(name,[]); groups.get(name).push(r); });
    const detailHeaders = ['ID','Agenda','Cliente','Serviço','Total','Insumos','Getnet %','Antecip. %','Comissão %','Auxiliar R$','Receber'];
    let detail = '';
    let totalReceber = 0;
    for (const [name, records] of groups) {
      const subtotal = records.reduce((a,r)=>a+moneyNumber(r.receber),0);
      totalReceber += subtotal;
      const rows = records.map(r=>`<tr>${printCell(r.id)}${printCell(datePrint(r.agenda))}${printCell(r.cliente)}${printCell(r.serv)}${printCell(moneyPrint(r.valor),true)}${printCell(moneyPrint(r.insumos),true)}${printCell(r.getnet,true)}${printCell(r.antecip,true)}${printCell(r.porc,true)}${printCell(moneyPrint(r.flex_receber || '0,00'),true)}${printCell(moneyPrint(r.receber),true)}</tr>`);
      rows.push(`<tr class="subtotal"><td colspan="10">Subtotal • ${escapePrint(name)} (${records.length} apontamentos)</td>${printCell(moneyPrint(subtotal),true)}</tr>`);
      detail += `<div class="group-title">${escapePrint(name)} — ${records.length} apontamentos</div>${printTable(detailHeaders,rows,'detail')}`;
    }
    // AUX FLEX: somar somente comissoes por SERVICO (flex_receber), nunca
    // o total semanal do profissional que tambem atua como auxiliar.
    // Acumular centavos evita erros de ponto flutuante na totalizacao.
    const comissoesAuxiliaresCentavos = RelComiss.reduce((centavos, lancamento) =>
      centavos + Math.round(moneyNumber(lancamento.flex_receber) * 100), 0);
    const comissoesAuxiliares = comissoesAuxiliaresCentavos / 100;
    const totalComAuxiliares = totalReceber + comissoesAuxiliares;
    detail += `<div class="group-title">Comissões dos profissionais principais: ${escapePrint(moneyPrint(totalReceber))}</div>`;
    detail += `<div class="group-title">Comissões Auxiliares: ${escapePrint(moneyPrint(comissoesAuxiliares))}</div>`;
    detail += `<div class="group-title">Total geral a receber (apontamentos + auxiliares): ${escapePrint(moneyPrint(totalComAuxiliares))}</div>`;
    const content = `<section class="report-section"><h2>Resumo da Semana</h2>${printTable(['Profissional','Total de Vendas','Débitos','A Receber','Vendas (%)','Rentabilidade (%)'],sumRows,'summary')}</section><section class="report-section"><h2>Apontamentos por Profissional (${RelComiss.length})</h2>${detail || '<p>Sem apontamentos no período.</p>'}</section>`;
    abrirRelatorioImpressao('Conferência Semanal',`Período: ${ini} a ${fim} • Caixa selecionado: ${global.cxselecionado || ''}`,content,true);
  }

  function printReactTable(params) {


    window.print()
    
  }

  function pageRelComiss(params) {
    window.onload = function() {
      //cl("carregou");
  };
    return (
      <div id="panelRelComiss" name="panelRelComiss" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-primary cardAddBgg collapsed-card" id="cardRelComiss" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloRelComiss">Relatório de Conferência da Semana Atual ({moment(global.dataConsCaixa).day(1).format('DD/MM')} à {moment(global.dataConsCaixa).day(7).format('DD/MM/YYYY')})</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse" >
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                      <div className="no-print" style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap', marginBottom: 8 }}>
                        <button type="button" className="btn bg-gradient-info btn-sm" onClick={imprimirSomenteResumoSemanal}>Imprimir Resumo da Semana</button>
                        <button type="button" className="btn bg-gradient-info btn-sm" onClick={imprimirConferenciaSemanal}>Imprimir Conferência Semanal</button>
                      </div>
                      <label id="labelReactTabulatorCxMovResumo" htmlFor="lNome">Resumo nesta Semana ({moment(global.dataConsCaixa).day(1).format('DD/MM')} à {moment(global.dataConsCaixa).day(7).format('DD/MM/YYYY')})</label>
                        <div id="divReactTabulatorCxMov" >
                          <ReactTabulator
                            name="rcardSelCaixaBody"
                            id="rcardSelCaixaBody"
                            // ref={(ref)}
                            columns={columnsRelResumo}
                            data={RelComissResumo}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={optionsRelResumo}
                            events={{}}
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          /><div>
                            <br />&nbsp;<br />
                          </div>

                        </div>
                        <label id="labelReactTabulatorCxMov" htmlFor="lNome">Apontamentos Localizados nesta Semana ({moment(global.dataConsCaixa).day(1).format('DD/MM')} à {moment(global.dataConsCaixa).day(7).format('DD/MM/YYYY')})</label>
                        {agendaDetalheId&&<MovimentoAgendasDetalhe agendaId={agendaDetalheId} onClose={()=>setAgendaDetalheId(null)}/>}

                        <img id="imgloadingRelComissResumo" style={{ display: '' }} className="row col-md-12" alt="Loading.." src={Loading}></img>
                        <div id="divReactTabulatorCxMov" >
                          <ReactTabulator
                            name="rcardSelCaixaBody"
                            id="rcardSelCaixaBody"
                            // ref={(ref)}
                            columns={columnsRel}
                            data={montarApontamentosComFlex(RelComiss)}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={optionsRel}
                            events={{/* renderComplete: function (data) {
                              console.log('renderComplete');
                            },
                            tableBuilt: function (data) {
                              console.log('tableBuilt');
                            } */}
                          }
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          />
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function Movresumo(params) {
    const prePagamentos = resumirPrePagamentosCaixa(Array.isArray(Lancamentos) ? Lancamentos : []);
    const moedaResumo = centavos => (centavos / 100).toLocaleString('pt-BR', {style:'currency',currency:'BRL'});
    const dataCaixaCurta = (() => { const m = String(global.cxselecionado || '').match(/\d{2}\/\d{2}\/\d{4}/); if (m) return m[0]; const d = moment(global.dataConsCaixa); return global.dataConsCaixa && d.isValid() ? d.format('DD/MM/YYYY') : ''; })();
    return (
      <div id="panelMovresumo" name="panelMovresumo" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-info cardAddBgg collapsed-card" id="cardMovAction" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Resumo Caixa e Vendas (agendas){dataCaixaCurta ? ' - ' + dataCaixaCurta : ''}</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formMovActions">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <div id="divSaldos" className="resumo-caixa">
                          <div className="resumo-kpis">
                            <div className="resumo-kpi resumo-kpi-entradas">
                              <label id="labelTotal" htmlFor="inputTotal">Total de Entradas</label>
                              <input type="text" className="form-control" disabled id="inputTotal" />
                            </div>
                            <div className="resumo-kpi resumo-kpi-saldo" id="idSaldoCaixa">
                              <label id="labelCash" htmlFor="inputCash">Saldo no Caixa</label>
                              <input type="text" className="form-control" disabled id="inputCash" />
                            </div>
                          </div>
                          <div className="resumo-grid">
                            {[['inputDebito','Débito'],['inputCCv','Crédito à Vista'],['inputCCp','Crédito Parcelado'],['inputPix','PIX'],['inputCC','Ficha(CC)']].map(([id,rotulo]) => <div className="resumo-item" key={id}>
                              <label htmlFor={id}>{rotulo}</label>
                              <input type="text" className="form-control" disabled id={id} />
                            </div>)}
                            {[['pre_pago','Pré-pago utilizado','Pré-pago (s/ entrada)'],['permuta','Permuta utilizada','Permuta (s/ entrada)']].map(([campo,nome,curto])=><div className="resumo-item" key={campo}>
                              <label htmlFor={'inputResumoUso_' + campo} title={nome + ' (sem nova entrada)'}>{curto}</label>
                              <input id={'inputResumoUso_' + campo} className="form-control" disabled value={(Array.isArray(Lancamentos)?Lancamentos:[]).filter(r=>r.tipo==='E'&&r.status==='inicial').reduce((s,r)=>s+realParaNumber(r[campo]||'0'),0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}/>
                            </div>)}
                          </div>
                          <div className="resumo-card">
                            <div className="resumo-card-titulo">Resumo de Faturamento (Agendas - Caixa de {global.cxselecionado})</div>
                            <div className="resumo-card-corpo resumo-cols-5">
                              {[['inputTotalagendas','Total - Agendas'],['inputTotalagendascartao','Agenda - Cartão'],['inputTotalagendaspix','Agenda - PIX'],['inputTotalagendascc','Agenda - Ficha(CC)'],['inputTotalagendascash','Agenda - Dinheiro']].map(([id,rotulo]) => <div className="resumo-col" key={id}>
                                <label htmlFor={id}>{rotulo}</label>
                                <input type="text" className="form-control" disabled id={id} />
                              </div>)}
                            </div>
                          </div>
                          <div className="resumo-duo">
                            <div className="resumo-card resumo-card-compacto">
                              <div className="resumo-card-titulo">Resumo de Vales - Caixa de {global.cxselecionado}</div>
                              <div className="resumo-card-corpo resumo-cols-1">
                                <div className="resumo-col">
                                  <label htmlFor="inputTotalvales">Total - Vales</label>
                                  <input type="text" className="form-control" disabled id="inputTotalvales" />
                                </div>
                              </div>
                            </div>
                            <div className="resumo-card resumo-card-compacto resumo-card-prepag">
                              <div className="resumo-card-titulo">Resumo de Pré-pagamentos - Caixa de {global.cxselecionado}</div>
                              <div className="resumo-card-corpo resumo-cols-3">
                                {[
                                  ['inputTotalPrePagamentos','Total recebido',prePagamentos.recebidos],
                                  ['inputEstornosPrePagamentos','Estornos',prePagamentos.estornados],
                                  ['inputLiquidoPrePagamentos','Entrada líquida',prePagamentos.liquido]
                                ].map(([id,rotulo,valor]) => <div className="resumo-col" key={id}>
                                  <label htmlFor={id}>{rotulo}</label>
                                  <input id={id} type="text" className="form-control caixa-resumo-valor" disabled value={moedaResumo(valor)}/>
                                </div>)}
                              </div>
                              <div className="resumo-card-rodape"><i className="fas fa-info-circle" /> {prePagamentos.quantidade} recebimento(s) de adiantamento neste caixa. O uso nas OS aparece acima e não gera nova entrada.</div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function Movaction(params) {
    return (
      <div id="panelMovaction" name="panelMovaction" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-danger cardAddBgg collapsed-card" id="cardMovAction" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Operações</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formMovActions">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <div id="divSaldos" >
                          <div className="form-row">
                            <div className="form-group col-md-10" id="idSaldoCaixa">

                            </div>
                            <div className="row col-md-12" id="alterarEbotoes">
                              <div className="row col-md-12">
                                <div className="col-sm">
                                  <div className="form-group ">
                                    <button type="button" className="btn btn-success  " id="btnMovCxFecharCx" onClick={() => btnconfirmFechaCx()}>Fechar Caixa</button>
                                    &nbsp;
                                    <button type="button" className="btn btn-danger float-right" id="btnMovCxSaiMan" onClick={() => confirmMovCx()}>Entrada/Saida Manual</button>
                                    &nbsp;
                                  </div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }


  function CaixaFechamento(params) {
    return (
      <div id="panelCxOpen" name="panelCxOpen" style={{ position: 'relative', display: 'none' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-info cardAddBgg" id="cardSelFech" style={{ display: '' }}>
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Fechamento Selecionado : {global.gLancSelected}</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelFechBody">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-7">
                        <img id="imgloadingReactTabulatorCxMov" style={{ display: '' }} className="row col-md-12" alt="Loading.." src={Loading}></img>
                        <div id="divReactTabulatorCxMov" >
                          <label htmlFor="lNome">Itens Localizados</label>
                          <ReactTabulator
                            name="rcardSelFechBody"
                            id="rcardSelFechBody"
                            // ref={(ref)}
                            columns={columns}
                            data={Lancamentos}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={options}
                            events={{}}
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          />
                          <label id="labelTotal" htmlFor="lCep">Total</label>
                          <div className="input-group-prepend">
                            <input type="text" className="form-control" disabled id="inputTotal" />
                          </div>
                        </div>
                      </div>
                      <div id="divFormadePG" style={{ display: 'none' }} className="form-group col-md-4">
                        <div className="row">
                          <label id="labelTCalc" name="labelTCalc">Formas de Pagamento</label>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Dinheiro</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCash" className="btn btn-info " onClick={() => btnFPG('inputVCash')} ><i className="fa fa-money"></i> </button>
                              <input type="text" onBlur={() => calcTroco()} onKeyDown={e => keyDetect(e.key)} className="form-control" id="inputVCash" />
                            </div>
                          </div>
                          <div className="form-group col-md-4 ">
                            <label htmlFor="lEmail3">Troco</label>
                            <div className="input-group-prepend">
                              <input type="text" className="form-control" id="inputVTroco" disabled />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Débito</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCD" className="btn btn-info " onClick={() => btnFPG('inputVCD')} ><i className="fa fa-credit-card-alt "></i> </button>
                              <input type="text" className="form-control" id="inputVCD" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Crédito à vista</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCC" className="btn btn-info " onClick={() => btnFPG('inputVCC')} ><i className="fa fa-credit-card"></i> </button>
                              <input type="text" className="form-control" id="inputVCC" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Crédito Parcelado</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCCx" className="btn btn-info " onClick={() => btnFPG('inputVCCx')} ><i className="fa fa-credit-card"></i> </button>
                              <input type="text" className="form-control" id="inputVCCx" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">PIX</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgPix" className="btn btn-info " onClick={() => btnFPG('inputVPix')} ><i className="fa fa-qrcode"></i> </button>
                              <input type="text" className="form-control" id="inputVPix" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row" title="Credito Corrente (Ficha Interna) - Somente um fechamento por vez">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3" >CC</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgConta" className="btn btn-info " onClick={() => btnFPG('inputVConta')} ><i className="fa fa-creative-commons "></i> </button>
                              <input type="text" className="form-control" id="inputVConta" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group col-md-12">
                        <button type="button" className="btn btn-info float-right" id="btnGravar" onClick={e => btnFinalizarPG()}>Finalizar Pagamento</button>
                        <button type="button" className="btn btn-info " id="btnGravarClose" onClick={e => CloseEditContr()}>Cancelar</button>
                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function testCaixa(params) {




  }

  function validaNome(params) {
    const eNnome = document.getElementById('inputNome')
    const nome = eNnome.value;
    if (nome.length > 3) {
      eNnome.classList.add("is-valid");
      eNnome.classList.remove("is-invalid");
      global.inpAddFrmC.inputNome = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function validaCid(params) {
    const eNnome = document.getElementById('inputCidade')
    const nome = eNnome.value;
    if (nome.length > 5) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      global.inpAddFrmC.inputCid = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function validaEmail4(params, idinput) {
    const eNemail = document.getElementById('inputEmail4')
    const email = eNemail.value;
    if (EmailValidator.validate(email)) {
      eNemail.classList.add("is-valid")
      eNemail.classList.remove("is-invalid")
      global.inpAddFrmC.inputEmail4 = true;
      //cl("true global valida", global.inpAddFrmC)
    } else {
      eNemail.classList.add("is-invalid")
      eNemail.classList.remove("is-valid")
      //cl("FALSE global valida", global.inpAddFrmC, params)
      if (params === 1) { return eNemail.focus() }
    }
    if (email) { eNemail.value = params.toLowerCase() };

  }

  function validaFone(params) {
    const eNnome = document.getElementById('inputFone')
    const nomep = eNnome.value;
    const nome = nomep.replace(/_|-/g, '');
    ////cl(nome)
    if (nome.length > 9) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      //global.inpAddFrmC.inputFone = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
    let im = new Inputmask("(99) 99999-9999");
    im.mask(eNnome);

  }

  function formataFone(params) {
    const nome = params.replace(/_|-/g, '');
    ////cl(nome)
    //eNnome.value = params.toLowerCase();
    let im = new Inputmask("99-999999999");
    let result = im.mask(params);
    return result;

  }


  function validaObs(params) {
    const eNnome = document.getElementById('inputObs')
    const nome = eNnome.value;
    if (nome.length > 5) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      global.inpAddFrmC.inputObs = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function CloseEditContr(params) {
    btnFPGresetAll();
    dualChangeLancReset();
    AtuRefresh();
    let ecardSelCaixa = document.getElementById('cardSelCaixa');
    ecardSelCaixa.classList.remove("collapsed-card");

    let ecardSelCaixaBody = document.getElementById('cardSelCaixaBody');
    if (ecardSelCaixaBody) { ecardSelCaixaBody.style.display = ''; }

    let ecardSelFech = document.getElementById('cardSelFech');
    if (ecardSelFech) { ecardSelFech.style.display = 'none'; }

  }

  function AtuRefresh(params) {

    setAtuLanc({ '0': '0' });

  }

  function btnFPGresetAll(params) {
    let einputVCash = document.getElementById('inputVCash');
    if (einputVCash) { einputVCash.value = ''; }
    let einputVTroco = document.getElementById('inputVTroco');
    if (einputVTroco) { einputVTroco.value = ''; }
    let einputVCD = document.getElementById('inputVCD');
    if (einputVCD) { einputVCD.value = ''; }
    let einputVCC = document.getElementById('inputVCC');
    if (einputVCC) { einputVCC.value = ''; }
    let einputVCCx = document.getElementById('inputVCCx');
    if (einputVCCx) { einputVCCx.value = ''; }
    let einputVPix = document.getElementById('inputVPix');
    if (einputVPix) { einputVPix.value = ''; }
    let einputVConta = document.getElementById('inputVConta');
    if (einputVConta) { einputVConta.value = ''; }

    /*     let einputVCash = document.getElementById('inputVCash');
        if (einputVCash) { einputVCash.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVCD = document.getElementById('inputVCD');
        if (einputVCD) { einputVCD.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVCC = document.getElementById('inputVCC');
        if (einputVCC) { einputVCC.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVCCx = document.getElementById('inputVCCx');
        if (einputVCCx) { einputVCCx.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVPix = document.getElementById('inputVPix');
        if (einputVPix) { einputVPix.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVConta = document.getElementById('inputVConta');
        if (einputVConta) { einputVConta.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */
  }

  function btnFPG(params) {
    btnFPGresetAll();
    let eparams = document.getElementById(params);
    if (eparams) {
      eparams.value = global.gSubTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      eparams.focus();
    }

  }

  function calcTroco(params) {
    let einputVCash = document.getElementById('inputVCash');
    let einputVTroco = document.getElementById('inputVTroco');
    let cash = realParaNumber(einputVCash.value);
    let troco = 0;
    //cl(LancSelected);
    troco = cash - global.gSubTotal
    if (troco > 0) {
      let einputVCashFormat = cash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      einputVCash.value = einputVCashFormat;
      //cl(einputVCashFormat);
      einputVTroco.value = troco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

    } else {
      let trocozero = 0;
      let einputVCashFormat = einputVCash.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      einputVCash.value = einputVCash.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      //cl(einputVCashFormat);
      einputVTroco.value = trocozero.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }

    //cl("troco",troco);

  }

  function dualChangeLanc(params) {
    let eimgloadingReactTabulatorCxMov = document.getElementById('imgloadingReactTabulatorCxMov');
    if (eimgloadingReactTabulatorCxMov) { eimgloadingReactTabulatorCxMov.style.display = ''; }
    global.gParams = params;
    setLancSelected(params)
    //cl("params", params)
    setAtuLancamentos({ idagenda: global.gParams })
    setAtuRelComiss({ idagenda: global.gParams })
    setAtuRelComissResumo({ idagenda: global.gParams })
    let qtd = 0;
    var i;
    var j;

    for (i = 0; i < params.length; i++) {
      // cl("params_i", params[i])
      let idfilter = params[i];
      var arrFound = Lanc.filter(function (item, num) {
        return item.value === idfilter;
      });
      let idcliente = arrFound[0]['cliente'];
      var arrFoundCli = Lanc.filter(function (item, num) {
        return item.cliente === idcliente;
      });

      // cl("arrFound", arrFound[0]['cliente'])
      // cl("arrFoundCli", arrFoundCli)

      for (j = 0; j < Lanc.length; j++) {
        //cl("compLanc",arrFound[0]['cliente'])
        if (Lanc[j]['cliente'] === arrFound[0]['cliente']) {
          //cl("Somou Lanc")
          qtd = qtd + 1;
        }
      }
    }

    if (qtd > 1) {
      //window.alert("Atenção : existem mais de um fechamento em aberto deste cliente! ")
      setLanc(arrFoundCli);
      //cl("params.length", params.length)
      // cl("arrFoundCli.length", arrFoundCli.length)

      if (arrFoundCli.length !== params.length) {

        modalBase("Atenção", "Existem mais de um fechamento em aberto deste cliente!");

      } else {
        qtd = 1;
      }
    }



    if (params.length > 0) {


      let ecardSelCaixa = document.getElementById('cardSelCaixa');

      let ecardSelCaixaBody = document.getElementById('cardSelCaixaBody');
      if (qtd > 1) {
        if (ecardSelCaixaBody) { ecardSelCaixaBody.style.display = ''; }
        ecardSelCaixa.classList.remove("collapsed-card");
      } else {
        if (ecardSelCaixaBody) { ecardSelCaixaBody.style.display = 'none'; }
        ecardSelCaixa.classList.add("collapsed-card");

      }

      let ecardSelFech = document.getElementById('cardSelFech');
      if (ecardSelFech) { ecardSelFech.style.display = ''; }


    } else {

      let ecardSelFech = document.getElementById('cardSelFech');
      if (ecardSelFech) { ecardSelFech.style.display = 'none'; }

    }


  }

  function keyDetect(params) {

    if (params === "Enter") {

      calcTroco();

      //  cl("key", params)
    }


  }

  function dualChangeLancReset(params) {
    global.gParams = [];
    setLancSelected();
    //cl("params", params)
    setAtuLancamentos({ idagenda: global.gParams })
    setAtuRelComiss({ idagenda: global.gParams })
    setAtuRelComissResumo({ idagenda: global.gParams })
    AtuRefresh();

  }


  if (repCaixaOpen.length < 1) {
    //if (0 == 1) {
    return (
      <div className="content-wrapper" >
        <div className="container-login100-form-btn">
          <img id="imgloading" width="250px" alt="Loading.." src={Loading}></img>

        </div>
        <div className="text-center p-t-30">Aguarde, Localizando Caixa ...</div>
      </div >
    )
  } else {
    return (
      <div className="content-wrapper">

        {ajusteFechado && <div role="dialog" aria-modal="true" style={{position:'fixed',inset:0,zIndex:2600,background:'rgba(0,0,0,.5)',display:'flex',justifyContent:'center',alignItems:'center',padding:12}} onClick={()=>setAjusteFechado(null)}>
          <div className="card card-info" style={{width:'min(760px,96vw)',maxHeight:'92vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
            <div className="card-header"><h3 className="card-title">Correção administrativa — Movimento #{ajusteFechado.id}</h3></div>
            <div className="card-body">
              <div className="form-group"><label>Agenda</label><select className="form-control" value={ajusteAgenda} onChange={e=>selecionarAgendaAjuste(e.target.value)}>{ajusteAgendas.map(id=><option key={id} value={id}>Agenda #{id}</option>)}</select></div>
              <div className="form-group"><label>Tipo de alteração</label><select disabled={!ajustePermitido} className="form-control" value={ajusteTipo} onChange={e=>{setAjusteTipo(e.target.value);setAjusteDestino('');}}><option value="transferir_agenda">Transferir agenda inteira</option><option value="transferir_servico">Transferir serviço específico</option><option value="aux_flex_salvar">Adicionar, trocar ou remover AUX FLEX</option></select></div>
              {ajusteTipo!=='transferir_agenda' && <div className="form-group"><label>Serviço</label><select disabled={!ajustePermitido} className="form-control" value={ajusteLinha} onChange={e=>setAjusteLinha(e.target.value)}><option value="">Selecione...</option>{ajusteServicos.filter(s=>Number(s.idservico)>0).map(s=><option key={s.id} value={s.id}>#{s.id} — {s.descricao_servico||'Serviço'} ({s.nome_profissional||''})</option>)}</select></div>}
              <div className="form-group"><label>{ajusteTipo==='aux_flex_salvar'?'Auxiliar FLEX':'Profissional de destino'}</label><select disabled={!ajustePermitido} className="form-control" value={ajusteDestino} onChange={e=>setAjusteDestino(e.target.value)}><option value="">{ajusteTipo==='aux_flex_salvar'?'Nenhum (remover AUX FLEX)':'Selecione...'}</option>{(ajusteTipo==='aux_flex_salvar'?ajusteFlex:ajusteProfissionais).map(p=><option key={p.id} value={p.id}>{p.nome}</option>)}</select></div>
              <div className="form-group"><label>Justificativa obrigatória (mínimo 20 caracteres)</label><textarea disabled={!ajustePermitido} className="form-control" rows="3" value={ajusteMotivo} onChange={e=>setAjusteMotivo(e.target.value)}/></div>
              {ajusteErro && <div className="alert alert-danger">{ajusteErro}</div>}
              <div className="alert alert-info">Somente alteração de profissional ou AUX FLEX. {REGRA_PRAZO_SEMANAL} Nenhum valor de caixa será alterado.</div>
            </div><div className="card-footer text-right"><button type="button" className="btn btn-success mr-2" disabled={ajusteSalvando || !ajustePermitido} onClick={salvarAjusteFechado}>Revisar e confirmar</button><button type="button" className="btn btn-danger" onClick={()=>setAjusteFechado(null)}>Fechar</button></div>
          </div>
        </div>}
        {CaixaFechado()}
        {CaixaAberto()}
        {Movresumo()}
        {Movaction()}
        {pageRelComiss()}
        {/* {testCaixa()} */}
      </div>
    )

  }



}

export default Gerador   